export default {
	global: {
		aeroporto: 'Aeropuerto',
		pais: 'Pais',
		salvandoGerandoRastreamento: 'Guardar y generar seguimiento',
		ticket: 'Entrada',
		chamadoSuporte: 'Llamados de Soporte',
		gestaoDe: 'Gestión de',
		contratos: 'Contratos',
		assinarTodosOsTrechos: 'Suscribir todos los extractos',
		vooAssinadoPeloPiloto: 'Vuelo firmado por el Piloto',
		selecioneUmaMoeda: 'Seleccione una moneda',
		mudarMoeda: 'Cambiar la moneda',
		fragil: 'Frágil',
		embalagemJaCadastrada: 'Paquete ya registrado',
		tipoEmbalagemCadastro: 'Tipo de embalaje caducado con éxito',
		aunqueNoFueCerrado: 'AUNQUE NO FUE CERRADO',
		exportacaoDados: 'Exportación de datos',
		naoNecessarioImprimirRelprev: 'No es necesario imprimir RELPREV',
		vooAssinadoPeloMecanico: 'Vuelo firmado por el Mecánico',
		tipoAplicacao: 'Tipo de aplicación',
		vooAssinadoPeloOperador: 'Vuelo firmado por el operador',
		naoFoiPossivelCadastrarUsuario: 'No se puede registrar el usuario',
		dac: 'DAC',
		avisoDeInicializacao: 'Advertencia de inicio',
		naoHaDiariosDeBordo: 'No hay libros de registro abiertos, libros de registro sin firmar y discrepancias abiertas',
		vencimento: 'Fecha de vencimiento',
		produto: 'Produto',
		trechoAgrupadoPor: 'Trecho agrupado por',
		baixar: 'Descargar',
		nenhumDiarioDisponivelParaAssinatura: 'Ningún diario de a bordo disponible para la firma.',
		naoSaiaDessaTela: 'No salga de esa pantalla, esto interrumpirá el proceso.',
		todosOsDiariosForamAssinados: 'Ok! Todos los Diarios de Bordo de esa aeronave fueron firmados.',
		gerar: 'Generar',
		adicionarPontos: 'Añadir Puntos',
		materias: 'Materias',
		concluidoNoTotalDe: 'completado en total de',
		caminha0:'Camión',
		nenhumaInformacaoEncontrada: 'Nenhuma Informação Encontrada',
		maisInformacoes: 'Mas informaciones',
		exibirTodas: 'Mostrar Todos',
		noLlenado: 'NO LLENADO',
		noMes: 'en el mes',
		emAberto: 'En abierto',
		tas: 'Tas',
		assinadosPorMim: 'Firmado por mí',
		tempoVooMuitoGrande: 'Tiempo de vuelo muy grande',
		exportarJSON: 'Exportar JSON',
		removeTrechoVoltaHorimetro: 'Quita el tramo y vuelve el horímetro',
		tipoUltimaIntervencao: 'Tipo de la última intervención',
		tipoProximaIntervencao: 'Tipo de la próxima intervención',
		horasCelulaProximaInspecao: 'Horas Célula Próx. Inspección',
		responsavelPeloRetorno: 'Responsable del retorno',
		ciclosTotais: 'Ciclos Totales',
		parciais: 'Parcial',

		horimetroInicialCelula: 'Hor. Inicio Célula',
		horimetroFinalCelula: 'Hor. Final Célula',
		totalDePartidas: 'Total de Salidas',
		totalDePousos: 'Total de Pisos',
		totalDeGancho: 'Total de Gancho',
		totalDeGuincho: 'Total de Guincho',
		totalDeCiclosNG: 'Total de Ciclos NG',
		totalDeCiclosNF: 'Total de Ciclos NF',

		objetivosAlcancados: '¿Se ha alcanzado el objetivo?',
		parcial: 'Parcial',
		carregandoListas: 'Cargando Listas',
		assinaturaDigitalPilotoComando: 'Firmado digitalmente por el piloto en comando',
		assinaturaDigitalMecanico: 'Firmado digitalmente por el mecánico',
		assinaturaDigialInspetor: 'Firmado digitalmente por el inspector',
		assinadoDigitalmentePor: 'Firmado digitalmente por',

		nenhumMotorAcionado: 'Ningún motor accionado',
		agrupado: 'Agrupados',
		gerarOrdemServico: 'Generar orden de servicio',
		aPartirDe: 'Desde',
		abaixoDe: 'Abajo de',
		acimaDe: 'Encima de',
		acimaDos: 'Por encima de los',
		passouTolerancia: 'Pasó de la tolerancia',
		tipoTarefa: 'Tipo de tarea',
		tolerancia: 'Tolerancia',
		emTolerancia: 'en tolerancia',
		pontualOuCondicao: 'Puntual o bajo condición',
		inspecaoAtiva: 'Inspección Activa',
		inspecaoDesativada: 'Inspección deshabilitada',
		desejaEncerrarEsseDespacho: 'Desea cerrar este auto',

		objetivosMissaoAlcancados: '¿Se alcanzaron los objetivos de la misión?',
		ocorrencias: 'Ocurrencias',
		codigoClassificacao: 'Código de clasificación',
		qualificacaoCivil: 'Cualificación civil',
		descricaoDosFatos: 'Descripción de los hechos',
		adicionarOcorrencia: 'Añadir Ocurrencia',
		tooltipQualificacaoCivil:
			'Mejor cualificación civil posible de las personas implicadas (nombre completo, documento de identificación utilizado para el embarque, nacionalidad y fecha de nacimiento, entre otros).',
		tooltipDescricaoFatos: 'Descripción de los hechos, necesariamente, informando qué y cómo se dio la ocurrencia.',
		tooltipLocalOcorrencia:
			'Lugar de ocurrencia, necesariamente, por el código de localidad o coordenada geográfica si en el suelo y, obligatoriamente por coordenada geográfica, si en vuelo.',
		discrepanciasTecnicas: 'Discrepancias Técnicas',
		acoesTomadas: 'Acciones',
		inverter: 'Reverso',
		totalHorasPiloto: 'Total de Horas (Piloto)',
		decimo: 'Décimo',
		galao: 'Galón',
		litros: 'Litros',
		libras: 'Libras',

		selecionarDespacho: 'Seleccione una Orden',
		maisDeumDespacho: 'Encontramos más de un despacho para esa aeronave, seleccione qué despacho ese vuelo se refiere.',
		nenhumDespacho: 'No encontramos ningún despacho para esa aeronave, seleccione uno en la lista o introduzca un despacho.',
		nenhumaDiscrepanciaAberta: 'Ninguna discrepancia abierta.',
		todasDiscrepanciasConcluidas: 'Todas las discrepancias completadas',
		gerarOrdemMissao: 'Generar Orden de Misión',
		indisponibilizarAeronave: 'Indisponibilizar la aeronave?',
		selecioneInspecaoAbaixo: 'Seleccione una inspección abajo',
		adicionarInspecoes: 'Agregar Inspecciones',
		aposSelecionarInspecao: 'Después de seleccionar todas las inspecciones que desee, haga clic en \'Agregar inspecciones\'.',
		visualizarOrdemServico: 'Ver Orden de Servicio',
		todasInspecoesAssinadaPeloMecanico: 'Todas las inspecciones firmadas por el mecánico.',
		todasInspecoesAssinadaPeloInspetor: 'Todas las inspecciones firmadas por el inspector',
		assinarMecanico: 'Suscripción mecánica',
		assinarInspetor: 'Suscribir Inspector',
		descricaoServico: 'Descripción del Servicio',
		dataExecucao: 'Fecha Ejecución',
		concluiEssaInspecao: 'Concluí esa Inspección',
		dataConclusao: 'Fecha de Finalización',
		disponivelParaRetorno: 'Disponible para el retorno',
		ordemDeServicoSalvaComSucesso: 'La orden de servicio guarda con éxito',
		ordemDeServicoConcluida: 'Orden de Servicio Completado',
		aeronaveNaoRetornouAoServico: 'La aeronave no retornó al servicio, ya que existe un(s) orden(s) abierto',

		cancelarOrdemServico: '¿Desea CANCELAR esta orden de servicio?',
		carregandoOrdemServico: 'Cargando Orden de servicio',
		cumpridoConformeDocumentacaoReferencia: 'Cumplido conforme a la documentación de referencia.',
		ordemServicoManutencao: 'Orden de Servicio de Mantenimiento',
		adicionarPeloMenosUmaInspecao: 'Usted tiene que agregar al menos una inspección.',
		excluindo: 'Excluyendo',
		inpecoesAssinadas: 'Inspección(es) firmada(s).',
		processandoManutencao: 'Procesando mantenimiento (esto puede tardar un poco)',

		adicionarDocumentacao: 'Agregar documentación',
		nenhumaDocumentacaoAdicionada: 'Ninguna Documentación agregada',
		naoCalculado: 'No calculado',
		semValor: 'Sin valor',
		vencido: 'Vencido',
		novaDocumentacao: 'Nueva Documentacion',
		ultimaData: 'Última fecha',
		documentos: 'Documento(s)',
		proximo: 'Seguiente',
		documentacaoSalva: 'Documentación Salva',
		lista: 'lista',
		diagonal: 'Diagonal',
		alterar: 'Cambio',
		tooltipReabrirDespacho: 'Reabrir Despacho',
		encerrar: 'Cerrar',
		cliqueNoHistoricoParaCarregar: 'haga clic en el historial para cargarlo.',
		nenhumHistoricoEncontrado: 'ningún historial encontrado.',
		// RELATORIOS
		acumuladoAno: 'Acumulado Año',
		acumuladoMes: 'Acumulado Mes',
		diaAnterior: 'Dia anterior',
		voos: 'Vuelos',
		extrato: 'Extracto',
		extratoDiarioDeBordo: 'Extracto Diario de Bordo',
		selecione: 'Seleccionar',
		gerarExcel: 'Generar Excel',
		relatorioMetaHorasVoadas: 'Informe de las Horas Voladas',
		relatorioHorasVoadas: 'Informe de Horas Voladoras',
		todosOsTipos: 'Todos los Tipos',
		efetividade: 'Efectividad',
		servicos: 'Mantenimiento',
		metaMes: 'Meta Mes',
		metaAno: 'Meta Anual',
		indicadorAno: 'Indicador anual',
		indicadorMes: 'Indicador Mes',
		aeronavesAsasRotativas: 'Aeronaves Asas Rotativas',
		aeronavesAsasFixas: 'Aeronaves Asas Fijas',
		gerandoRelatorio: 'Generando Informe',
		favorPreencherCamposEmVermelho: 'Por favor llene el (los) campo (s) en rojo.',
		naoFoiPossivelGerarRelatorio: 'No se pudo Generar Informe',
		metaHoras: 'Meta Horas',
		voadas: 'Voladas',
		auditoria: 'Auditoría',
		relatorioAlocacao: 'Informe de Asignación',
		relatorio: 'Informe',

		relatorioIndicadorEfetividade: 'Informe de Indicador de Efectividad',
		resultadosObtidos: 'Resultados obtenidos',
		meta: 'Meta',
		varIndMeta: 'var % ind/meta',
		acumulado: 'Acumulado',
		mesAtual: 'Més Actual',
		relatorioHorasDeVoo: 'Informe de Horas de Vuelo',
		nomeCompleto: 'Nombre Completo',
		nomeDaUnidade: 'Nombre de la Unidad',
		instrutor: 'Entrenador',
		indicador: 'Indicator',
		servico: 'Servicio',
		horasDeVooApoio: 'Horas de vuelo en apoyo',
		relatorioPrestacaoDeContas: 'Informe de Cuentas de Cuentas',
		aeronavesOperadasPelo: 'Aeronaves Operadas por el',
		auditoriaDiarioDeBordo: 'Auditoría Diario de Bordo',
		processarAuditoria: 'Procesamiento de Auditoría',
		verificados: 'Escaneado',
		dataProcessamento: 'Fecha Procesamiento',
		ausentes: 'Ausente',
		corrompidos: 'Corrompido',
		validos: 'Válido',
		arquivosAusentesCorrompidos: 'Archivos Ausentes / Corrompidos',
		numeroDiario: 'Número de Diario',
		arquivo: 'Archivo',
		registro: 'Registro',
		requisitos: 'Requisitos',
		preRequistos: 'Prerrequisitos',
		relatorioOVN: 'Informe GVN',
		perfilTripulacao: 'Perfil de la tripulación',
		todasAsFuncoes: 'Todas las funciones',
		horasVooTripulacao: 'Horas de Vuelo Tripulación',
		acumuladoNoPeriodo: 'Acumulado en el Período',
		experienciaRecente: 'Experiencia reciente - Últimos 90 días',
		horasVoo: 'Horas de vuelo',
		ultimoVoo: 'Último Vuelo',
		satelite: 'Satélite',

		// submenu Adm Geral
		cadastroDeDocumentacao: 'Registro de Documentación',
		cadastroPontosInteresse: 'Registro de Puntos de Interés',
		cadastroTipoEmbalagem: 'Registro del Tipo de Paquete ',
		planoDeFundo: 'Fondo de Pantalla',
		gerenciamentoVoo: 'Gestión de Vuelo',
		logProcessamento: 'Registro de Procesamiento',
		configBackend: 'Configuracion del Backend',
		dadosDoCliente: 'Datos del Cliente',
		cadastroAtividade: 'Registro de Actividad',
		metaIndicadores: 'Meta e indicadores',
		pontos: 'Marcadores',

		// Cadastro Usuario
		novoSimplificado: 'Nuevo Simplificado',
		listarNovosUsuarios: 'Listar Nuevos Usuarios',
		usuariosDesativados: 'Usuarios Deshabilitados',
		usuarioDesativado: 'Usuario Deshabilitado',
		cadastroUsuarioSimplificado: 'Registro de Usuario Simplificado',
		editarUsuarioSimplificado: 'Editar Usuario Simplificado',
		cpfUsadoComoLoginEsenha: 'El número de CPF se utilizará como LOGIN y CONTRASEÑA, que deberá cambiarse en el primer acceso.',
		ativarUsuario: 'Activar el Usuario',
		desejaAtivarEsseUsuario: '¿Desea habilitar este usuario?',
		desejaDesativarEsseUsuario: '¿Desea deshabilitar este usuario?',
		desativarUsuario: 'Desactivar el Usuario',
		emBrancoMantemAssinatura: 'En blanco, mantenga la misma firma',
		alterarAssinaturaNoProximoLogin: 'Cambiar la firma en el siguiente inicio de sesión?',
		hAssinatura: 'Firma',

		// Perfil
		carregaAutomaticoPerfilAoCriarUsuario: 'Cargar automáticamente este perfil al crear un nuevo usuario?',
		diarioDeBordoMecanico: 'Diario de Bordo Mecánico',
		cartaDeSituacaoOperacoes: 'Carta de Situación Operaciones',
		diarioDeBordoOperador: 'Diario de Bordo Operador',

		// Prevenção Qualificada
		horariosMaisComuns: 'Horarios más comunes',
		dadosDaPrevencao: 'Datos de la Prevención',
		minutos: 'Minutos',
		voltarMapa: 'Volver al mapa',
		zqc: 'ZCC',
		zonaQuenteCriminalidade: 'Zona Caliente de Criminalidad',
		desejaCancelarPrevencao: '¿Desea CANCELAR esa prevención?',

		contatosMissao: 'Contactos de la Misión',
		novoContato: 'Nuevo contacto',
		discrepancia: 'discrepancia',
		comandanteLocalMissao: 'Comandante de la misión en el lugar',

		selecioneUmaAero: 'Seleccione una aeronave para comenzar.',
		posicoes: 'Posiciones',
		cadastroUnidadeConservacao: 'Registro de Unidad de Conservación',
		municipio: 'Ciudad',
		areaMapeamento: 'Área de Mapeo',
		areaMonitoramento: 'Área de Monitoreo',
		areaCriacao: 'Área de Creación',
		esfera: 'Alcance',
		operador: 'Operador',
		eOperador: 'es el operador',
		operadorIndefinido: 'El operador no se ha definido',
		manutencaoNaoDeuParecer: 'El mantenimiento no ha dador',
		manutencaoDeuParecer: 'Tiene el parecer del mantenimiento',
		naoTemParecerManutencao: 'No tiene el parecer del mantenimiento',
		operacoesNaoDeuParecer: 'La operación no dio la opinión',
		operacoesDeuParecer: 'Tiene el dictamen de las operaciones',
		naoTemParecerOperacoes: 'No tiene el parecer de las operaciones',
		naoDefinido: 'No definido',
		aprovado: 'Aprobado',
		naoAprovado: 'No aprobado',
		inseridoPor: 'Inserido por:',
		finalizadoPor: 'Finalizado por:',
		emExecucao: 'En ejecución',
		emAnalise: 'En análisis',
		preenchimentoConcluido: 'Relleno completado',
		indeterminada: 'Indeterminado',
		semSolicitacao: 'No hay pedidos',
		adicionarLayer: 'Agregar capa',
		layer: 'Capa',
		arquivo: 'Archivo',
		descricaoLayer: 'Descripción para capa',
		descricaoCompleta: 'Descripción completa',
		PermissoesAcessoLayers: 'Permisos de acceso a capa',
		gestaoLayer: 'Gestión de Capas',
		novoLayer: 'Nueva capa',
		layerCadastradoSucesso: '¡Capa registrada con éxito!',
		layerAtualizadoSucesso: '¡Capa actualizada con éxito!',
		layerExcluidoSucesso: '¡Capa eliminada correctamente!',
		desejaExcluirEssaPermissao: '¿Realmente desea eliminar este permiso?',
		desejaExcluirEmbalagem: '¿Desea excluir este embalaje?',
		embalagemExcluidaComSucesso: 'Embalaje excluido con éxito.',
		permissaoExcluida: 'Permiso eliminado',
		desejaExcluirEsseLayer: '¿Quieres eliminar esta capa?',
		salvarNovoPadrao: 'Guardar nuevo patrón',
		importarLayer: 'Importar capa',
		importar: 'Importar',
		inclusao: 'Inclusión',
		incluir: 'Incluir',
		padrao: 'Estándar',
		geral: 'General',
		cadastroLayer: 'Registro de capa',
		multicamadasMapa: 'Multicapa en el mapa',
		administrativa: 'Administrativo',
		termino: 'Final',
		terminoOrdem: 'Terminación de la orden',
		temUmTermino: 'Tiene un término',
		apareceraDespachoAeronaves:
			'Aparecerá en el Despacho de Aeronaves hasta la opción \'Terminar este despacho?\' se marca como SIM.',
		dataTermino: 'Fecha de finalización',
		situacao: 'Situación',
		naoHaEmpregoAeronave: 'No hay empleo de aeronave',
		determinacaoSessaoManutencao: 'Conforme a la determinación de la sesión de mantenimiento',
		aeronaveTurnoServico: 'Aeronave del turno de servicio',
		adicionarBase: 'Añadir la base',
		semPassageiros: 'Sin Pasajeros',
		naoHaCarga: 'No hay carga',
		naoHaRoteiro: 'No hay guía',

		despacho: 'Despacho',
		tipoDespacho: 'Tipo de Despacho',

		dataAbertura: 'Fecha de apertura',
		instrutorVoo: 'Instructor de Vuelo',
		obrigPilotoComando: 'Obligatorio para el Piloto en Comando',
		obrigInstrutorVoo: 'Obligatorio para el instructor de vuelo',

		solicitaUsoAeronave: 'Solicitud de uso de aeronave',
		horimetroInicial: 'Hor. Inicial',
		horimetroFinal: 'Hor. Final',
		aval: 'Endoso',

		adendo: 'Apéndice',
		dataHoraCadastro: 'Fecha-Hora Registro',
		tipoMapa: 'Tipo Mapa',
		ativo: 'Activo',
		fechado: 'Cerrado',
		mapa: 'Mapa',

		gerarPrevencao: 'Generar Prevención',
		despachoAeronaves: 'Despacho Aeronaves',
		demandaReprimida: 'Demanda Reprimida',
		motivacao: 'Motivación',
		semVitimas: 'Sin Víctimas',
		codinome: 'Con nombre en código',
		selecioneOrdemMissaoAbaixo: 'Seleccione la orden a la siguiente misión.',
		exibirEncerradas: 'Mostrar Cerradas',
		exibirFaturaEmAtraso: '¿Mostrar mensaje "Factura vencida"?',
		alinhaTabela: 'Alinear Tabla',
		solicitacaoInserida: 'Solicitud insertada en el sistema.',
		dadosDaMissaoPreenchidos: 'Todos los datos de la orden de misión se han cumplido, está a la espera de entrar en ejecución.',
		processoEmAndamento: 'Proceso en curso de una orden de misión o despacho.',
		dataAtualMaiorUltimoTrecho: 'La fecha actual es mayor que el último tramo de la orden de misión.',
		todosProcessosOrdemMissaoOuDespachoConcluidos: 'Todos los procesos de la orden de misión o de la orden se concluyeron.',
		emExecucaoOuAberta: 'En ejecución o abierta',
		emExecucaoVencida: 'En ejecución vencida',

		nenhumaSolicitacaoParaEssesDias: 'Ninguna Solicitud para estos días',
		nenhumaOrdemParaEssesDias: 'Ninguna orden para estos días',
		nenhumDespachoParaEssesDias: 'Ninguno Despacho para estos días',
		tarefas: 'Tareas',
		exibirConcluidos: 'Mostrar completadas',
		esconderConcluidos: 'Esconder Terminadas',
		enterSalvaEscCancela: 'ENTRAR para guardar y ESC para cancelar',
		ate: 'para',

		despachos: 'Despachos',
		contexto: 'Contexto',
		Por: 'Por',
		mensagem: 'Mensaje',
		mensagemFaturaAberta: 'Este es un recordatorio de que su factura está abierta. Realiza el pago para evitar inestabilidad en el sistema FollowAir. En caso de duda, póngase en contacto con el sector financiero. Si ya se ha realizado el pago, ignore este mensaje',
		nenhumaConversaEncontrada: 'Ninguna conversación encontrada.',
		enviar: 'Enviar',
		voce: 'Usted',
		semMaisConversa: 'sin más conversación.',
		todosOsTrechos: 'Todos los extractos',
		souPiloto: 'Soy Piloto',
		piloto: 'Piloto',
		de: 'De',

		assinadoPor: 'Firmado por',
		cliqueTrechoCarregar: 'Haga clic en el tramo para cargarlo.',
		diario: 'Diario',
		tempoTotalPiloto: 'Tiempo total del piloto:',
		anac: 'Anac',
		naoHaDiscrepancia: 'No hay discrepancias',
		despachoDeAeronaves: 'Despacho de Aeronaves',
		acoes: 'Acciones',
		autoLocalizacao: 'Auto Localización',
		voo: 'Vuelo',
		armasApreendidas: 'Armas aprehendidas',
		pessoasDetidas: 'Personas detenidas',
		pessoasSalvas: 'Personas Salvas',
		valorRecuperado: 'Valor Recuperado',
		bambiBucket: 'Bambi Bucket',
		adicionarDespacho: 'Añadir al despacho',
		alterarDespacho: 'Modificar el despacho',
		ressalvas: 'Reservas',
		nenhumaRessalvaAdicionada: 'Ninguna Reserva Agregada',
		adicionarRessalva: 'Añadir salvedad',
		tempoSobrevoo: 'Tiempo de Sobrevuelo',
		desejaExcluirEsseDespacho: '¿Desea eliminar esta orden?',
		helicopteros: 'Helicópteros',
		seguro: 'Seguro',
		disponivel: 'Disponible',
		indisponivel: 'Indisponible',
		atividadesAereas: 'Actividades Aereas',
		relatorioPerfil: 'Informe de perfil',
		eUsuario: 'y Usuario',
		relatorioDiarios: 'Informe diario',
		naoAssinados: 'No firmados',
		atividadesAereasGeral: 'Actividades Aéreas General',
		ordemMissaoPrevencaoQualificada: 'Orden de Misión de Prevención Cualificada',
		selecioneOrdemMissaoPrevencaoQualificada: 'Seleccione una orden de misión de prevención cualificada',
		selecioneOrdemMissaoPrevencaoAbaixo: 'Seleccione la orden de misión de prevención que se describe a continuación.',
		ativa: 'Activo',
		preventiva: 'Preventivo',
		copiloto: 'Copiloto',
		pilotoInstrucao: 'Piloto en Instrucción',
		pilotoComando: 'Piloto en el mando',
		operadorAerotatico: 'Operador Aerotático',
		estagiario: 'Aprendiz',
		canceladaComSucesso: 'Cancelada con éxito',
		prevencaoQualificada: 'Prevención Cualificada',
		prevencaoSalva: 'Prevención Salva',
		numeroPrevencao: 'Número de la Prevención',
		despachoExcluido: 'Despacho Excluido',
		tempo: 'Tiempo',
		reabrirDespacho: '¿Desea volver a abrir este despacho?',
		despachoReaberto: 'Despacho Reabierto.',
		reabrindo: 'Reapertura',
		cancelarDespacho: 'Cancelar el envío',
		carregandoDiarios: 'Cargando diarios',
		carregandoComponentes:'Cargando los componentes',
		chegada: 'Llegada',
		ordensDeMissao: 'Órdenes de Misión',

		documentacao: 'Documentación',
		ordemDeServico: 'Orden de Servicio',
		horasVoadasAbreviacao: 'HV',
		desativarInspecao: 'Desactivar la Inspección',
		ativarInspecao: 'Activar Inspección',
		refOrigem: 'Ref Origen',
		ativar: 'Activar',
		desativar: 'Desactivar',
		para: 'para',
		justificativaInspecao: 'esta inspección se requiere una justificación',
		tituloTarefa: 'Título de la Tarea',
		numeroTarefa: 'Número de Tareas',
		numeroPeca: 'Número de Pieza',
		irParaOrdemServico: 'Para ir a trabajar',
		intervaloServico: 'Intervalo de Servicio',
		ultimoServico: 'Último Service',
		abertura: 'Apertura',
		relatorioPerfilUsuario: 'Informe Perfil y Usuario',
		diariosDeBordoNaoAssinados: 'Libros de registro sin firmar',
		numeroDB: 'Número *DB',
		novoKit: 'Nuevo Kit',
		kitComissaria: 'Kit de Comisaría',
		quantosItens: '¿Cuántos elementos?',
		dadosKit: 'Datos del Kit',
		quantidade: 'Cantidad',
		ocorreuErroTenteNovamente: 'Se produjo un error, inténtalo de nuevo',
		deveConterMininoUm: 'Debe contener al menos 01',
		oKitDeveConterUmItem: 'El kit debe contener un mínimo de 1 elemento',
		cadastroFornecedor: 'Registro de Proveedor',
		novoFornecedor: 'Nuevo Proveedor',
		razaoSocial: 'Razón Social',
		nomeContato: 'Nombre de Contacto',
		desejaExcluirFornecedor: '¿Desea eliminar este proveedor?',
		fornecedor: 'Proveedor',
		dadosFornecedor: 'Datos del Proveedor',
		cnpj: 'CNPJ',
		termoDeUso: 'Término de Uso',
		cadastroDeBase: 'Registro de Base',
		controleInpencoesComponentes: 'Control de Inspecciones y Componentes',
		escola: 'Escuela',
		gestaoInterna: 'Gestión Interna',
		baseOperacional: 'Base Operativa',
		forcarAssinarTermo: 'Forzar firmar término?',
		salvarTermo: 'Quardar Término',
		termoAtualizado: 'Término Actualizado',
		graus: 'Grados',
		decimal: 'Decimal',
		vooRegular: 'Vuelo Regular',
		carregarModelo: 'Cargar Plantilla',
		atualizandoModelosAeronaves: 'Actualización de los modelos de las aeronaves',
		atualizando: 'Actualización',
		modelosAtualizados: 'Modelos actualizados',
		novaCategoria: 'Nueva Categoría',
		exibirDesativados: 'Ver Deshabilitados',
		editarCategoria: 'Editar Categoría',
		exibirLegendas: 'Ver subtítulos',
		editarCapitulo: 'Editar Capítulo',
		novoCapitulo: 'Nuevo Capítulo',
		necessarioPeloMenosUmaInspecao: 'Se requiere al menos una inspección para actualizar',
		capitulo: 'Capítulo',
		carregandoModelo: 'Cargando modelo',
		componentes: 'Componentes',
		componente: 'Componente',
		// Término..

		cadComissaria: 'Registro de Comisaria',
		numReds: 'Nro. REDS',
		numChamada: 'Nro. Llamada',
		numAtividade: 'Nro. Actividad',
		subEclassificacao: 'Subclasificación y Clasificación',
		descricaoDaMissao: 'Descripción de la misión',
		idadeAparente: 'Edad Aparente',
		sexo: 'Género',
		vitimas: 'Víctimas',
		usoDeFlir: 'Uso de FLIR',
		usoDeOvn: 'Uso de OVN',
		ordemEncerrada: 'Orden cerrada',
		origemDoVoo: 'Origen del vuelo',
		tripulacao: 'Tripulación',
		cadTripulacao: 'Registro de Tripulación',
		proa: 'Arco',
		combustivel: 'Combustible',
		combustivelInicial: 'Combustible Inicial',
		combustivelConsumido: 'Combustible Consumido',
		combustivelTotal: 'Combustible Total',
		solicitacoes: 'Solicitudes',
		digiteSeuLogin: 'Introduzca su nombre de usuario.',
		irParaO: 'IR PARA EL',
		textoSenhaAlteradaSucesso: 'Su contraseña ha cambiado con éxito!',
		textoModificarSenha: 'Para modificar su contraseña actual, introduzca la nueva contraseña en el campo siguiente.',
		naoFoiPossivelEncontrarDados: 'No se ha encontrado ningún dato a través de este login.',
		comUmLink: 'con un enlace para recuperar su contraseña!',
		enviamosUmEmail: 'Enviamos email para usted',
		avancar: 'Siguiente',
		textoDigiteSeuLogin: 'Introduzca su login que vamos a encontrar la mejor forma de establecer una nueva contraseña.',
		esqueceuSuaSenha: 'Olvidaste tu contraseña?',
		esqueciMinhaSenha: 'Olvide mi contraseña',
		carregarFoto: 'Cargar Foto',
		disponivelNa: 'Disponible en',
		excluirFoto: 'Excluir Foto',
		carrgandoFoto: 'Cargando foto',
		clickExibirApp: 'Haga clic aquí para acceder al Followair de su teléfono.',
		leiaQRCode: 'Lea el QR Code a través del Followair en su teléfono.',
		acessarApp: 'Acceder a App',
		departamento: 'Departamento',
		cadastroDeDepartamento: 'Registro de Departamento',
		sessao: 'Sesión',
		secao: 'Sección',
		cadastroDeSessao: 'Registro de sesión',
		cadastroDeSecao: 'Registro de sección',
		numeroCarne: 'Número de Carne',
		desejaExcluirEssaSolicitacao: '¿Desea eliminar esta solicitud?',
		excluidoComSucesso: 'Excluido con éxito.',
		todos: 'Todos',
		oUsuarioPodeAlterarSuasConfigs: 'El usuario puede editar su configuración?',
		carregandoManutencoes: 'Cargando mantenimiento',
		conjuge: 'Cónyuge',
		licenca: 'Licencia',
		numero: 'Número',
		voceJaAddItem: 'Te ha añadido este artículo.',
		exercicios: 'Ejercicios',
		novaDisciplina: 'Nueva Disciplina',
		disciplina: 'Disciplina',
		emHoras: 'En horas',
		disciplinaAtualizada: 'Disciplina actualizada',
		disciplinaInserida: 'Disciplina insertada',
		tipoDeVoo: 'Tipo de vuelo',
		solo: 'Suelo',
		dc: 'dc',
		horimetroInicialMotor: 'Horímetro de arranque del motor',
		horimetroInicialMotor: 'Horímetro final del motor',
		duracao: 'Duración',
		descricaoDoExercicio: 'Descripción del ejercicio',
		descricaoDoTema: 'Descripción del tema',
		nivelDeAprendizagem: 'Nivel de Aprendizaje',
		alterarSenha: 'Cambiar la contraseña',
		porQuestoesAlterarSenha: 'Por cuestiones de seguridad es necesario que cambie su contraseña.',
		digiteNovaSenhaAbaixo: 'Escriba la nueva contraseña en el campo siguiente.',
		novaSenha: 'Nueva contraseña',
		voceNovaSenha: 'Debe introducir la nueva contraseña.',
		alterandoSenha: 'Cambiar la contraseña',
		naoFoiPossivelAlterarSenha: 'No se pudo cambiar la contraseña.',
		atualizacao: 'Actualización',
		centralizar: 'Centralizar',
		sessaoExpirada: 'Sesión expirada',
		secaoExpirada: 'Sección expirada',
		algoDeuErrado: '¡Algo salió mal!',
		aconteceuUmProbleminha: '¡Ha ocurrido un problema al intentar hacer esta petición, pero tranquila!',
		seOErroPersistir: 'Si este error persiste, póngase en contacto con nuestro soporte.',
		regulamento: 'Reglamento',
		regulamentoAtualizado: 'Reglamento actualizado',
		regulamentoSalvo: 'Regulamento salvo',
		suaSessaoExpirou: 'Su sesión ha caducado.',
		suaSecaoExpirou: 'Su sección ha caducado.',
		digiteSuaSenhaParaRenovala: 'Introduzca su contraseña para renovarla.',
		vcTemQueDigitarSenha: 'Usted tiene que introducir su contraseña.',
		sessaoAtualizada: 'Sesión actualizada',
		secaoAtualizada: 'Sección actualizada',
		senhaInvalida: 'Contraseña no válida.',
		nenhumDadoEncontrado: 'Ningún dato encontrado para esa fecha.',
		matriculado: 'Matriculado',
		pendentePagamento: 'Pendiente Pago',
		dataNascimento: 'Fecha de Nacimiento',
		estadoCivil: 'Estado Civil',
		solteiro: 'Solo(a)',
		casado: 'Casado(a)',
		divorciado: 'Divorciado(a)',
		viuvo: 'Viuvo(a)',
		separado: 'Separado(a)',
		nacionalidade: 'Nacionalidad',
		naturalidade: 'Naturalidad',
		atualizado: 'Actualizado',
		atualizar: 'Actualizar',
		manutencoes: 'Mantenimiento',
		visaoGeral: 'Visión General',
		perfis: 'Perfiles',
		voo: 'Vuelo',
		registroHFDM: 'FDM',
		especial: 'Special',
		dadosDoVoo: 'De datos de vuelo',
		medicao: 'Medición',
		instrumentos: 'Instrumentos',
		escolhaUmaOpcaoAoLado: 'Elija una opción en el menú junto a.',
		sejaBemVindo: 'Seja bem-vindo ao',
		naoInformado: 'No informado',
		informacaovoo: 'Información de vuelo',
		infoOrdemDeMissao: 'Misión Solicitar Información',
		ordemDeMissao: 'Orden de Misión',
		apoiados: 'Apoyado',
		orgaos: 'Órganos',
		programacaoVoo: 'Programacion de Vuelo',
		atividades: 'Actividades',
		operacao: 'Operación',
		local: 'Lugar',
		velocidade: 'Velocidad',
		altitude: 'Altitud',
		solo: 'Terreno',
		altitudeVelocidade: 'Altitud y velocidad',
		graficos: 'Gráficos',
		lat: 'lat',
		lng: 'lng',
		direcao: 'Dirección',
		emMesesDias: 'en meses y días',
		deTrabalho: 'trabajo',
		revalidacao: 'Revalidación',
		renovacao: 'Renovación',
		ultima: 'Última',
		emMeses: 'en Meses',
		intervalo: 'Intervalo',
		previsaoDeData: 'Fecha Pronóstico',
		mesesDias: 'Meses y Días',
		oficina: 'Taller',
		horasTotais: 'El tiempo total',
		horasVoadas: 'Horas de Vuelo',
		nivel: 'Nível',
		calendaricas: 'Calendáricas',
		calendarica: 'Calendárico',
		porHoraVoada: 'Con alas por hora',
		homeHora: 'Hombre/Hora',
		trabalho: 'Trabajo',
		ultimaManutencaoRealizada: 'Se celebra el último mantenimiento',
		proximaInspecao: 'La inspección cercana',
		descricao: 'Descripción',
		descricao: 'Descripción ANP',
		cadastroCombustiveis: 'Registro de combustible',
		escolherItemAcima: 'Tienes que elegir uno o más elementos anteriores.',
		obrig: 'Requerido',
		variacoes: 'Variaciones',
		escritorio: 'Escritório',
		equipe: 'Equipo',
		estado: 'Estado',
		usuario: 'Usuario',
		todasNturezas: 'Todas Naturalezas',
		tempoTotal: 'Tiempo Total',
		todas: 'Todos',
		disponibilidade: 'Disponibilidad',
		previsao: 'Previsión',
		manutencao: 'Mantenimiento',
		ciclos: 'Ciclos',
		guarnicao: 'Guarnición',
		telaCheia: 'Pantalla Completa',
		sairTelaCheia: 'Salir Pantalla Completa',
		posicao: 'Posición',
		hora: 'Hora',
		aeronave: 'Aeronave',
		carregandoDados: 'Cargando datos',
		anexo: 'Anexo',
		bairro: 'Barrio',
		usuarios: 'Usuarios',
		trecho: 'Tramo',
		total: 'Total',
		buscar: 'Digite para buscar en la lista a continuación',
		novo: 'Nuevo',
		nova: 'Nueva',
		imprimir: 'Imprimir',
		excluir: 'Excluir',
		criar: 'Agregar',
		voltar: 'Volver',
		salvar: 'Guardar',
		gerarRelatorio: 'Generar Informe',
		carregar: 'Cargar',
		sair: 'Salir',
		fechar: 'Cerrar',
		concluir: 'Concluir',
		visualizar: 'Visualizar',
		telefone: 'Teléfono',
		decolagem: 'Despegue',
		pouso: 'Aterrizaje',
		totalDia: 'Total en el día',
		dataInicio: 'Fecha Inicio',
		dataFim: 'Fecha Fin',
		data: 'Fecha',
		ou: 'O',
		ano: 'Año',
		mes: 'Mes',
		status: 'Estado',
		prioridade: 'Prioridad',
		horasDisponivel: 'Horas disponibles',
		quantidadeDeDias: 'Número de días',
		codigo: 'Código',
		solicitante: 'Solicitante',
		gerarOrdem: 'Generar Orden',
		editar: 'Editar',
		alterarStatus: 'Alterar Estado',
		cidade: 'Ciudad',
		obrigatorio: 'Campos con * son obligatorios',
		campoObrigatorio: 'Este campo es obligatorio.',
		paraAddObrigatorio: 'Para este nuevo campo es obligatorio.',
		solicitado: 'Solicitado',
		lotacao: 'Capacidad',
		email: 'Correo electrónico',
		inicio: 'Inicio',
		fim: 'Fin',
		retrair: 'Retraer',
		perfil: 'Perfil',
		titulo: 'Para generar el informe, llene los siguientes campos',
		cadastro: 'Registro',
		solicitacao: 'Solicitud',
		cancelar: 'Cancelar',
		carregando: 'Cargando',
		enviando: 'Enviando',
		obs: 'Observación',
		salvando: 'Guardando',
		excluindo: 'Excluyendo',
		escolha: 'Elección',
		escolhaOpcaoAbaixo: 'Elija una acción a continuación',
		excluirUsuario: 'Excluyendo usuario',
		ola: 'Hola',
		filtro: 'Filtros',
		voando: 'Volando',
		ultimo: 'Último',
		evento: 'Evento',
		info: 'Información',
		equipamentos: 'Equipamientos',
		grupos: 'Grupos',
		nomeModelo: 'Nombre del modelo',
		todosGrupos: 'Todos los grupos',
		naturezas: 'Naturalezas',
		todasNaturezas: 'Todas las naturalezas',
		filtrar: 'Filtrar',
		exibir: 'Exhibir',
		tipo: 'Tipo',
		natureza: 'Naturaleza',
		grupo: 'Grupo',
		dias: 'Días',
		meses: 'Meses',
		anos: 'Años',
		horas: 'Horas',
		dataManutencao: 'Fecha Mantenimiento',
		totalHorasVoadas: 'Total de Horas Voladas',
		totalCiclosVoados: 'Total de Ciclos Volados',
		privilegio: 'Privilegio',
		nome: 'Nombre',
		nomeAdicionado: 'Nombre añadido',
		responsavel: 'Responsable',
		conclusao: 'Conclusión',
		aberta: 'Abierto',
		concluida: 'Completada',
		cancelada: 'Cancelada',
		fem: 'Femenino',
		masc: 'Masculino',
		end: 'Dirección',
		remover: 'Eliminar',
		sim: 'Sí',
		nao: 'No',
		modulo: 'Seleccione el módulo que desea acceder',
		matricula: 'Matrícula',
		inscricao: 'Inscripción',
		curso: 'Curso',
		categoria: 'Categoría',
		validade: 'Validez',
		habilitacao: 'Habilitación',
		observacao: 'Observación',
		aluno: 'Alumno',
		pacote: 'Paquete',
		valor: 'valor',
		parcela: 'Parcela',
		maximo: 'Máximo',
		parcelas: 'Las parcelas',
		adicionar: 'Añadir',
		forma: 'Pago',
		em: 'En',
		totalPago: 'Total Pago',
		formaDePagamento: 'Forma de pago',
		faltaPagar: 'Falta pagar',
		msgPagamentoMaiorPagamento: 'Usted está agregando un valor mayor que la compra.',
		administracaoEscolar: 'Administración Escolar',
		selecioneParaExibir: 'Seleccione un elemento para abrir la configuración.',
		escolaDeVoo: 'Escuela de vuelo',
		valordaMatricula: 'valor de la matrícula',
		valorCursoTeorico: 'valor del curso teórico',
		valorHoraCursoPrático: 'valor del curso práctico',
		fabricante: 'Fabricante',
		orgao: 'Órgano',
		velocidadeMedia: 'Velocidad Media',
		consumo: 'Consumo',
		tanque: 'Tanque',
		escolhaoAluno: 'Elegir un Alumno',
		escolhaoCurso: 'Elegir un Curso',
		carregar: 'Cargar',
		comoDesejaFiltar: 'Elija la forma que desea filtrar',
		fechaExercicio: 'CERRAR EJERCICIO',
		exercicio: 'EJERCICIO',
		nomeESobrenomealuno: 'NOMBRE Y ÚLTIMO NOMBRE',
		planoDeRegistro: 'AVION MATRICULA',
		instruçãoDemissao: 'MISSION INSTRUCCIÓN',
		desembarque: 'N° ATERRIZAJE',
		tempoDeVoo: 'Tiempo de vuelo',
		avaliacaoGeral: 'EVALUACION GENERAL',
		nomeESobrenomeinstrutor: 'NOMBRE Y APELLIDO DEL INSTRUCTOR',
		grau: 'GRADO',
		assinatura: 'FIRMA',
		Marcacao: 'MARQUE LA FORMA DE EJECUCION DE LA MANIOBRA EN EL LUGAR CORRESPONDENTE',
		naoSatisfeito: 'NO SATISFACE',
		regular: 'REGULAR',
		excelente: 'EXELENTE',
		nice: 'BIEN',
		registroNome: 'INSCRIPCIÓN - NOMBRE',
		materiaEncerrada: 'Materia cerrada por',
		reabrir: 'ABRIR',
		verificacao: 'MARQUE LA FORMA DE EJECUCIÓN DE LA MANIOBRA EN EL LUGAR CORRESPONDIENTE',
		reabertura: 'Reabriendo',
		obrigacao: 'Obligatorio',
		camposObrigatorios: 'Debe introducir los campos obligatorios.',
		simulador: 'SIMULADOR',
		pratica: 'PRÁCTICA',
		teorico: 'TEÓRICO',
		matricula: 'MATRÍCULA',
		detalhes: 'Detalles',
		fatura: 'FATURA',
		pagamento: 'PAGO',
		pagamentoNaoEfetuado: 'Ningún pago efectuado.',
		adicionarPagamento: 'AGREGAR PAGO',
		detalhesDoPagamento: 'DETALLE DEL PAGO',
		pagamentoDetalhes: 'Pago',
		valorDoPagamento: 'Valor Pago',
		desconto: 'Descuento',
		pagamentoFeitoSucesso: 'Pago agregado con éxito',
		tipoDePagamento: 'Tipo de pago',
		valorTempoVoo: 'Valor de la hora de vuelo',
		cargaHoraria: 'Carga horaria',
		totalDoCurso: 'Total del curso',
		adicionar: 'ADICIONAR',
		numeroDaFatura: 'Número de factura',
		salvarPagamento: 'SALVAR',
		maiorValor: 'Mayor que el valor.',
		notificacao: 'NOTIFICACIONES',
		nenhumaNotificacao: 'Usted no tiene ninguna notificación',
		limpaTudas: 'Borrar todas',
		historico: 'Historia',
		hNotificacao: 'Notificaciones',
		limpar: 'Limpar',
		escolhaData: 'Elija una fecha',
		cCarregar: 'CARREGAR',
		voceTem: 'Tú tienes',
		nenhumaNotificacaoEncontrada: 'Ninguna notificación encontrada',
		notificacaoEncontrada: 'notificaciones encontradas',
		ver: 'Ver',
		naoSelecionouData: 'No ha seleccionado una fecha.',
		classificacaoESub: 'Clasificación e Subclasificación',
		cadastroMotor: 'Registro de motor',
		cadastroRotaer: 'Registro de Rotaer',
		contextoOperativo: 'Contexto Operativo',
		orgaosApoiados: 'Órganos apoyados',
		classificacao: 'Clasificación',
		subclassificacao: 'Subclasificación',
		novoMotor: 'Nuevo Motor',
		horimetro: 'Horímetro',
		motorAdicionado: 'Motor Añadido',
		motorAtualizado: 'Motor Actualizado',
		dadosMotor: 'Datos del motor',
		orgaoOperador: 'Órgano Operador',
		orgaoProprietario: 'Orgánico Propietario',
		computadorDeBordo: 'Computadora de Bordo',
		calculoSistema: 'Cálculo en el sistema',
		modeloAtualizado: 'Modelo Actualizado',
		modeloInserido: 'Modelo Añadido',
		fabricanteAtualizado: 'Fabricante Actualizado',
		fabricanteInserido: 'Fabricante Añadido',
		desejaExcluirContexto: '¿Desea eliminar este contexto operativo?',
		contextoExcluido: 'Contexto Operativo excluido.',
		contextoAtualizado: 'Contexto operativo actualizado',
		contextoSalvo: 'Contexto Operativo salvo',
		voceJaCadastrouItem: 'Usted ya ha registrado este artículo.',
		orgaoApoiadoAtualizado: 'Orgánico apoyado actualizado',
		orgaoApioadoSalvo: 'Orgón apoyado salvo',
		desejaExcluirClassificacao: '¿Desea eliminar esta clasificación?',
		classificacaoExcluida: 'Clasificación excluida',
		classificacaoSalva: 'Clasificación salvo',
		classificacaoAtualizada: 'Clasificación actualizado',
		subcategoria: 'Subcategoría',
		escolhaUmaClassificacaoPara: 'Seleccione una clasificación<br/> para ver la lista.',
		desejaExcluirSubclassificacao: '¿Desea eliminar esta subclasificación?',
		subclassificacaoExcluida: 'Subclasificación excluida',
		subclassificacaoSalva: 'Subclasificación salvo',
		subclassificacaoAtualizada: 'Subclasificación actualizado',
		designativo: 'Designador',
		salvo: 'Salvo',
		atualizado: 'Actualizado',
		qualDirigenteDesseOrgao: '¿Quién es el dirigente de este órgano?',
		operacional: 'Operacional',
		solicitante: 'Solicitante',
		tipoDeUsuario: 'Tipo de usuario',
		nomeTratamento: 'Nombre de tratamiento',
		enderecoResidencial: 'Dirección Residencial',
		enderecoFuncional: 'Dirección Funcional',
		assinaturaDigital: 'Firma digital',
		perfilDoUsuario: 'Perfil del usuario',
		alterarSenhaProximoLogin: 'Cambiar la contraseña en el siguiente inicio de sesión?',
		emergencia: 'Emergencia',
		positivo: 'Positivo',
		negativo: 'Negativo',
		alergia: 'Alergia',
		contatoDeEmergencia: 'Contacto de Emergencia',
		grauDeRelacionamento: 'Grado de Relación',
		telefoneResidencial: 'Teléfono residencial',
		telefoneCelular: 'Teléfono celular',
		jaExiste: 'Ya existe.',
		emailInvalido: 'E-mail no válido.',
		emailJaCadastrado: 'Correo electrónico ya registrado.',
		cpfJaCadastrado: 'CPF ya registrado.',
		voceJaAddEssePerfil: 'Usted ha agregado este perfil',
		voceTemAddUmPerfil: 'Usted tiene que agregar al menos un perfil.',
		assinaturaAvalicao: 'La firma debe tener 8 dígitos numéricos.',
		//numeroSolicitacao: 'Número de solicitud',
		recebidoPor: 'Recebido por',
		verTodos: 'Ver todos',
		desejaCancelarSolicitacao: '¿Desea cancelar esta solicitud?',
		solicitacaoCancelada: 'Solicitud cancelada.',
		nSolicitacao: 'Nro. de solicitud',
		// recebidoPor: 'Recebido por',
		// verTodos: 'Ver todos',
		// desejaCancelarSolicitacao: 'Deseja cancelar essa solicitação?',
		// solicitacaoCancelada: 'Solicitação cancelada.',
		codigoSituacao: 'Código - situación',
		caracteresRestantes: 'caracteres restantes.',
		novoTrecho: 'Nuevo tramo',
		quantos: '¿Cuántas?',
		trechosQueOPassEstara: 'Extractos que el pasajero estará',
		cargaTransportada: 'Carga Transportada',
		haCargaASerTransportada: '¿Hay carga a ser transportada?',
		solicitanteDaMissao: 'Solicitante de la Misión',
		voceEAAutoridadeSolicitante: 'Usted es la autoridad solicitante?',
		trecho: 'Tramo',
		percursoASerEfetuado: 'Recorrido a efectuar',
		partida: 'Salida',
		cidade: 'Ciudad',
		estado: 'Estado',
		destino: 'Destino',
		local: 'Lugar',
		naoTenhoUmAerodromoDefinido: 'No tengo un aeródromo definido.',
		haPassageiros: '¿Hay Pasajeros?',
		descricaoDoLocal: 'Descripción del sitio',
		passageirosDaAeronave: 'Pasajeros de la aeronave',
		pesoAprox: 'Peso Aprox.(Kg)',
		descricaoDaCarga: 'Descripción de la carga',
		cargaLiquida: '¿Carga Líquida?',
		preenchaOsDadosDoSolicitante: 'Rellene los datos de la autoridad solicitante.',
		enviarSolicitacao: 'Enviar solicitud',
		atualizarSolicitacao: 'Actualizar solicitud',
		resumoDaSolicitacao: 'Resumen de la solicitud',
		leiaSuaSolicitacao: 'Lea su solicitud y al final haga clic en "ENVIAR SOLICITUD".',
		solicitacaoSalva: 'Solicitud Salva',
		numeroSolicitacao: 'Número de solicitud',
		operacoes: 'Operaciones',
		aprovacao: 'Aprobación',
		foiGeradoUmCodigo: 'Se ha generado una orden de misión con código',
		irParaOrdemDeMissao: 'Ir a la orden de misión',
		definirOperador: 'Definir Operador',
		quemEOOperador: '¿Quién es el operador de esta solicitud?',
		aSolicitacaoFoiDefinida: 'La solicitud se ha definido para el operador',
		as: 'para',
		peloUsuario: 'por el usuario',
		essaSolicitaoTemOaval: '¿Esta solicitud tiene el aval de la Operación?',
		qualOMotivo: '¿Cuál es el motivo?',
		aSolicitaoTemOaval: 'La solicitud <strong>TIENE</strong> el aval de las operaciones.',
		aSolicitacaoNaoAval: 'La solicitud <strong>NO TIENE</strong> el aval de las operaciones.',
		motivo: 'Razón',
		qualAeronaveVaiSerUtilizada: '¿Qué aeronave se utilizará?',
		essaSolicitaoTemAvalManutencao: '¿Esta solicitud tiene el aval del Mantenimiento?',
		qualquerAeronave: 'Cualquier aeronave',
		aSolicitacaoTemAvalManutencao: 'La solicitud <strong>TIENE</strong> el aval del mantenimiento.',
		aSolicitacaoNaoTemAvalManutencao: 'La solicitud <strong>NO TIENE</strong> el aval del mantenimiento.',
		aprovarEssaSolicitacao: 'Aprobar esta solicitud (Generar orden de misión)?',
		aSolicitacaoEstaAprovada: 'La solicitud <strong>ESTÁ<strong> aprobada.',
		aSolicitacaoNaoTemAprovacao: 'La solicitud <strong>NO ESTÁ<strong> aprobada.',
		nOrdem: 'N Orden',
		escolhaOMotivoCancelamentoOrdem: 'Seleccione el motivo para cancelar la solicitud',
		indisponibilidadeEfetivo: 'Indisponibilidad de efectivo',
		indisponibilidadeAeronave: 'Indisponibilidade de aeronave',
		solicitanteCancelou: 'Solicitante canceló',
		outros: 'Otro',
		cancelarOrdem: 'Cancelar orden',
		cancelando: 'Cancelando',
		ordemCancelada: 'Orden cancelada',
		inicioDaOrdem: 'Inicio de la orden',
		descricaoDaOrdem: 'Descripción de la orden',
		descricaoOrdemDeMissao:'Descripción Orden de Misión',
		descricaoOrdemMissaoSalvoComSucesso: 'Descripción Orden de Misión se ha guardado correctamente.',
		descricaoOrdemMissaoExcluidoComSucesso: 'Descripción Orden de Misión eliminado correctamente.',
		orgaoApoiado: 'Órgano Apoyado',
		orgaoApoiadoUnidades: 'Órganos Compatibles - Unidades',
		orgaoApoiadoAtualizadoComSucesso: 'Órgano Compatible actualizado con éxito.',
		unidade: 'Unidad',
		unidadeDoOrgao: 'Unidad de Órgano',
		unidades: 'Unidades',
		ubidadeDeOrgaoApoiadoSalvoComSucesso: 'Unidad de órgano apoyado guardada con éxito',
		unidadeDoOrgaoApoiadoExcluidoComSucesso: 'Unidad de órgano apoyado eliminado con éxito',
		adicionarUnidade: 'Agregar unidad',
		adicionarOrgao: 'Añadir Órgano',
		haContextoOperativo: '¿Hay contexto operativo?',
		haResalvasNaSituacao: '¿Hay salvedades en la situación?',
		aeronavesEmpregadas: 'Aeronaves Empleadas',
		removerAeronave: 'Quitar Aeronave',
		funcao: 'función',
		adicionarTripulacao: 'Añadir Tripulación',
		passageiros: 'Pasajeros',
		adicionarPassageiro: 'Añadir Pasajeros',
		copiar: 'Copia',
		roteiro: 'Guión',
		atualizarRoteiro: 'Actualizar Guión',
		nascer: 'Salida',
		por: 'Puesta',
		distancia: 'Distancia',
		autonomia: 'Autonomía',
		tempoEstimado: 'Tiempo estimado',
		distanciaCalculada: 'Distancia Calculada',
		destinoAproximado: 'Destino Aproximado',
		velocidadeAtual: 'Velocidad actual',
		reguaDigital: 'Regla digital',
		totais: 'Totales',
		distanciaTotal: 'Distancia total',
		consumoTotal: 'Consumo total',
		tempoTotal: 'Tiempo total',
		atualizarMapa: 'Actualizar Mapa',
		fecharDadosDaAeronave: 'Cerrar datos de la aeronave',
		existemCampoDaAeroASerem: 'Existen campos a ser llenados en las aeronaves empleadas.',
		adicionarAeronave: 'Añadir Aeronave',
		execucao: 'Ejecución',
		haNecessidadeDeAbastecimento: '¿Hay necesidad de reabastecimiento?',
		diarias: 'Diario',
		haNecessidadeDeDiarias: '¿Hay necesidad de empeño de diarias?',
		reabastecimento: 'Reposición',
		comunicacoes: 'Comunicaciones',
		novaComunicacao: 'Nueva Comunicación',
		responsavelPelaCriacaoDaOrdem: 'Responável pela Confecção da Ordem de Missão',
		em: 'en',
		em2: 'en',
		nos: 'nudos',
		tempoEstimadoViaAr: 'ETA vía AÉREA',
		aeronaveParada: 'Aeronave detenida',
		regua: 'regla',
		milhasNauticas: 'Milhas Náuticas',
		milhas: 'Milhas',
		quilometros: 'Kilómetros',
		aOrdemInciaEm: 'El orden se iniciará en',
		reabrirOrdem: 'Reabrir Orden',
		fecharOrdemDeMissao: 'Cerrar el orden de misión',
		atualizarOrdemDeMissao: 'Actualizar Orden de Misión',
		resumoDaOrdemDeMissao: 'Resumo da Ordem De Missão',
		leiaAOrdem: 'Lea su orden y al final haga clic en "ACTUALIZAR ORDEN".',
		ordemDeMissaoSalva: 'Orden de Misión Salva',
		numeroDaOrdem: 'Número de orden',
		diarioDeBordo: 'Diario de a Bordo',
		pilotoECopiloto: 'Piloto y Copiloto',
		carregarVoos: 'Cargar Vuelos',
		voceTemQueEsperarPois: 'Usted tiene que esperar, pues',
		estaPreenchendoUmDiarioDeBordo: 'está llenando un diario para esa aeronave.',
		verificando: 'Viendo',
		inicial: 'Inicial',
		final: 'Final',
		assinar: 'Signo',
		preencher: 'Llenar',
		adicionarTrecho: 'Añadir Tramo',
		agruparTrecho: 'Agrupar Tramo',
		origem: 'Fuente',
		planejada: 'Planificado',
		critica: 'Crítica',
		emergencial: 'Emergencia',
		escolhaUmTrechoParaCopiar: 'Elija un tramo para que usted copie.',
		trechosAgrupados: 'Tramos Agrupados',
		abaixoEstaoOsTrechosAgrupados: 'A continuación están los tramos agrupados.',
		clickParaVerOsTrechosAgrupados: 'Haga clic para ver los vuelos agrupados',
		desagruparTrechos: 'Desagrupar tramos',
		voceNaoPodeAgrupar: 'Usted no puede desagrupar esos tramos, ya se han llenado.',
		agruparTrechos: 'Agrupar Tramos',
		selecioneOsTrechosAgrupados: 'Seleccione los tramos que se van a agrupar a continuación.',
		salvarTrechos: 'Guardar Tramos',
		juntadoTrechos: 'Juntando Tramos',
		trechoJuntado: 'Tramo agrupado.',
		osTrechosPrecisamSerSeqquencial: 'Los extractos seleccionados deben ser secuenciales.',
		desagrupando: 'Dispersante',
		trechoDesagrupado: 'Tramo desagrado.',
		verificandoSePodePreencher: 'Comprobar si puede llenar',
		desejaExcluirEsseTrecho: '¿Desea eliminar este fragmento?',
		desejaExcluirEsse: 'Desea eliminar este',
		verificacaoSePodeExcluir: 'Comprobar si se puede excluir',
		trechoExcluido: 'Tramo excluido.',
		voceNaoPodeExcluirEditando: 'Usted no puede excluir, alguien está llenando el diario.',
		oTrechoEstaAberto: 'El Tramo de <strong>{{INICIO}}</strong>, está abierto y necesita ser llenado.',
		trechoAdicionado: 'Tramos añadido.',
		vooPreenchidoPor: 'Vuelo completado',
		vooAssinadoPor: 'Vuelo firmado por',
		vooNaoPreenchido: 'Vuelo no rellenado',
		clickParaVerOsTrechosPor: 'Haga clic para ver los vuelos agrupados por',
		inseridoManualmentePor: 'Inserido manualmente por',
		esseTrechoNaoPodeSerPreenchido: 'Este tramo no puede llenarse ahora',
		nenhumVooEncontrado: 'Ningún vuelo fue encontrado.',
		ultimaInspecao: 'Última intervención',
		proximaInspecao: 'Siguiente intervención',
		horasDeCelulaParaAProxima: 'Horas de celda previstas para la próxima intervención',
		responsavelPelaAprovacao: 'Responsable por la aprobación para retorno al servicio',
		escolhaAOrigem: 'Seleccione el origen',
		desejaEncerrarEssaOrdemDeMissao: '¿Desea cerrar esta orden de misión?',
		motorEHorario: 'Motor y Horario',
		acionamento: 'actuación',
		novoAcionamento: 'Nuevo Accionamiento',
		tipoAcionamento: 'Tipo de Accionamiento',
		corte: 'Cortada',
		vooDecimoCelula: 'Vuelo Décimo Célula',
		vooDecimoMotor: 'Vuelo Décimo Motor',
		diurno: 'Diurno',
		noturno: 'Noturno',
		navegacao: 'Navegación',
		instrucao: 'Instrucción',
		dadosDoVoo: 'Datos del vuelo',
		combustivel: 'Combustible',
		relacao: 'Relación',
		partidas: 'Salidas',
		pousos: 'Aterrizajes',
		guincho: 'Cabrestante',
		gancho: 'Gancho',
		usoDe: 'Uso de',
		numeroDeVoo: 'Número de vuelo',
		escolhaAFuncaoTripulante: 'Seleccione la función de este tripulante',
		apresentacao: 'Presentación',
		vitima: 'Víctima',
		idadeAparente: 'Edad Aparente',
		passageiro: 'Pasajero',
		houveCargaTransportada: '¿Ha habido carga transportada?',
		discrepanciasVerificadas: 'Discrepancias Comprobadas',
		adicionarDiscrepancia: 'Añadir Discrepancia',
		dadosDaMissao: 'Datos de la misión',
		base: 'Base',
		naturezaDoVoo: 'Naturaleza del Vuelo',
		chamada: 'Llamada',
		atividade: 'Actividad',
		coracao: 'Corazón',
		rim: 'Riñón',
		figado: 'Hígado',
		cornea: 'Córnea',
		esclero: 'Esclero',
		pancreas: 'Páncreas',
		baco: 'Bazo',
		unidadeDeConservacao: 'Unidad de Conservación',
		baseDeOrigem: 'Base de Origen',
		brigadistas: 'bomberos',
		socorridos: 'Socorridos',
		finalizarTracho: 'Finalizar Tramo',
		editarTrecho: 'Editar Tramo',
		atualizarTrecho: 'Actualizar Tramo',
		assinarESalvarTrecho: 'Suscribir y guardar tramo',
		selecioneOTipo: 'Seleccione el tipo',
		com: 'Con',
		sem: 'Sin',
		selecioneUmaOrdemDeMissao: 'Seleccione una orden de misión',
		nenhumaOrdemFoiEncontrada: 'No se ha encontrado ninguna solicitud.',
		selecioneUmaAeronave: 'Seleccione una aeronave',
		naoEncontramosSuaAero:
			'No encontramos esa aeronave dentro de la orden de misión, si quería importar los datos de la aeronave de la orden de misión, basta con hacer clic en el modelo abajo.',
		selecioneOsPassageirosTrecho: 'Seleccione los pasajeros que volaron ese tramo',
		tempoDePreenchimento: 'Tiempo de llenado',
		desejaContinuarAPrrencher: '¿Desea continuar llenando este diario de a bordo?',
		continuar: 'Continuar',
		desejaFinalizarTrecho: '¿Desea finalizar este tramo?',
		desejaAtualizarTrecho: '¿Desea actualizar este tramo?',
		revisar: 'Revisión',
		finalizar: 'Final',
		assinarEFinalizar: 'Suscribirse y Finalizar',
		carregandoDiario: 'Carga diaria de a bordo',
		copiandoDiario: 'Copiando diario de a bordo',
		umDessesCampoEObrigatorio: 'Uno de estos campos es obligatorio.',
		voceTemQueEscolherUnidade: 'Usted tiene que agregar al menos una unidad.',
		carregandoHorimetro: 'Cargando horimetro',
		atualizandoTempo: 'Actualizando el tiempo',
		mecanico: 'Mecánico',
		discrepancias: 'Discrepancias',
		oTrechodeInicioTexto:
			'El tramo de inicio <strong>{{TRECHO}}</strong>, del día <strong>{{INICIO}}</strong>, está abierto y necesita ser llenado.',
		assinando: 'Firma',
		trechoAssinado: 'Tramo firmado',
		nenhumaAcao: 'Ninguna acción',
		acaoTomada: 'Acción Toma',
		concluido: 'Terminado',
		trigrama: 'Trigrama',
		avaliar: 'Evaluar',
		nenhumaDiscrepanciaEncontrada: 'Ninguna discrepancia encontrada',
		nenhumaAcaoFoiTomadaDiscrepancia: 'Ninguna acción fue tomada para esa discrepancia.',
		adicionarAcao: 'Añadir Acción',
		concluirDiscrepancia: 'Completar Discrepancia',
		discrepanciaConcluida: 'Discrepancias concluidas',
		acaoCorretiva: 'Acción correctiva',
		acaoPreventiva: 'Acción Preventiva',
		monitoramento: 'Monitoreo',
		indisponibilizarAeronave: 'Indisponibilidad Aeronave',
		responsavel: 'Responsable',
		acao: 'Acción',
		destinatarios: 'destinatarios',
		consumivel: 'Consumible?',
		novaAcao: 'Nueva Acción',
		novaDiscrepancia: 'Nueva Discrepancia',
		desejaConcluirEssaDiscrepancia: '¿Desea concluir esta discrepancia?',
		escolhaUmaAcao: 'Elija una acción anterior.',
		destinatario: 'Destinatario',
		gerarOrdemDeServico: 'Generar orden de servicio?',
		acaoSalva: 'Acción Salva',
		discrepanciaSalva: 'Discrepancia Salva',
		assinaturaEletronica: 'Firma Electrónica',
		digiteSuaAssinatura: 'Introduzca su suscripción',
		assinaturaInvalida: 'Firma no válida.',
		usoDeAereonave: 'Uso de la aeronave',
		cartaDeSituacao: 'Carta de Situación',
		prevencao: 'Prevención',
		qualificada: 'Cualificada',
		delito: 'Delito',
		modeloDoMapa: 'Modelo del Mapa',
		calor: 'Heat',
		marcadores: 'Markers',
		gerarMapa: 'Generar Mapa',
		resultados: 'Resultados',
		tentativas: 'Intentos',
		consumados: 'Consumado',
		totalDeOcorrencias: 'Total de ocurrencias',
		diasMaisComuns: 'Día más común',
		horarioMaisComum: 'Horario más común',
		horario: 'schedule',
		textoDiaDiscrepancia: 'tiene un mayor número de casos ocurriendo en el',
		textoHorarioDiscrepancia: 'en un horario próximo a las',
		localizacao: 'Ubicación',
		latitude: 'Latitud',
		latitudeInicial: 'Latitud Inicial',
		latitudeFinal: 'Latitud Final',
		longitude: 'Longitud',
		logitudeInicial: 'Longitud Inicial',
		logitudeFinal: 'Longitud Final',
		encaminharParaExecucao: 'Encaminhar a Ordem para execução',
		inicioOrdem: 'Início da Ordem',
		novoDespacho: 'Nuevo Despacho',
		numeroDoDespacho: 'Nº del despacho',
		encerrada: 'Cerrado',
		dadosDoDespacho: 'Datos del Despacho',
		primeiroPilotoComando: '1º Piloto en Mando',
		segundoPilotoComando: '2º Piloto en Mando',
		finalidade: 'propósito',
		calendarioSemanal: 'Calendario Semanal',
		adicionarVoo: 'Agregar Vuelo',
		selecionarSemana: 'Seleccione Semana',
		solicitacoesItensAvulsas: 'Solicitudes de un solo artículo',
		dataEmissao: 'Fecha de emisión',
		setorDestino: 'Sector objetivo',
		selecioneAeronave: 'Seleccione una Aeronave',
		unidadeArmazenamento: 'Almacenamiento de la unidad',
		duplicar: 'Duplicar',
		confirmarDuplicar: 'Confirma que desea duplicar',
		naoPossivelExcluirUnidadeMedidaSuprimentosLigados: 'No puede eliminar una unidad de medida con suministros adjuntos',
		estoqueUnidadeMedida: 'Inventario - Unidades de Medida',
		desejaExcluirUnidadeMedida: '¿Quieres eliminar esta unidad de medida?',
		sistemaIntegrado: 'Sistema Integrado',
		novoRelatorio: 'Nuevo Informe',
		anexoSolicitacao: 'Solicitud Anexo',
		mediaManual: 'Promedio manual',
		toleranciaDisponivel: 'Tolerancia disponible',
		oHorimetroDeveSerMenorQueOAtual: 'El contador de horas debe ser más pequeño que la corriente',
		disponibilizarAeronave: 'Disponibilizar Aeronave',
		indisponibilizarAeronave: 'Indisponibilizar Aeronave',
		porcentagem: 'Porcentaje',
		aeronaveDestino: 'Destino de la aeronave',
		eImportanteFazerEsseProcedimento: 'Es importante realizar este procedimiento antes de que la aeronave comience a volar',
		equipamentoTrocado: 'Equipo intercambiado',
		dataInvalida: 'Fecha Invalida',
		altitudeTerreno: 'Altitud Absoluta',
		alturaVoo: 'Altura del vuelo', 
		desejaExcluirEsse: '¿Quieres borrar esto',
		alturaVoo: 'Altura del vuelo',
		imagensCadastradas: 'Imágenes registradas',
		cadastrarImagens: 'Registrar imágenes',
		nenhumaImagemCadastrada: 'No hay imagen registrada',
		planoDeFundoAtual: 'Antecedentes actuales',
		definirPlanoDeFundo: 'Definir fondo',
		definirComoPlanoDeFundo: 'Puesto como fondo',
		excluirImagem: 'Eliminar Imagen',
		salvarImagem: 'Guardar imagen',
		anexeUmaImagem: 'Adjuntar una imagen',
		cliqueEmAlgumaImagem: 'Haga clic en cualquier imagen',
		cadastroTipoCarga: 'Registro de tipo de carga',
		suporte: 'Soporte',
		chamadaDeSuporte: 'Llamada de soporte',
		manualOnline: 'Manual en Linea',
		osArquivosNãoPodemSerMaiorQue: 'Los archivos no pueden ser más grandes que',
		interacaoSalva: 'Interacción guardada',
		sigla: 'Acrónimo',
		detalhar: 'Detalle',
		opcoes: 'Opciones',
		liquida: 'Líquida',
		perigosa: 'Peligroso',
		outras: 'Otros',
		cargaSalvaComSucesso: 'Carga guardada con éxito',
		houveUmErroAoTentarSalvar: 'Hubo un error al intentar guardar',
		erroConectarServidor: 'Error al conectarse al servidor.',
		desejaExcluirACarga: 'Quieres borrar la carga',
		cargaExcluidaComSucesso: 'Carga eliminada correctamente',
		tipoOrdemDeMissao:'Tipo de Orden de Misión',
		tipoOrdemMissaoSalvoComSucesso: 'El Tipo Orden de Misión se ha guardado correctamente',
		tipoOrdemMissaoExcluidoComSucesso: 'Tipo Orden de Misión eliminado correctamente',
		valorNumericoInvalido: 'Valor numérico no válido.',
		quantidadeEstimadaPassageiros: 'Número estimado de pasajeros',
		tipoCombustivel: 'Tipo de combustible',
		unidadeOrcamentaria: 'Unidad Presupuestaria',
		quantidadeDeLitros: 'Cantidad de Litros',
		valorDoLitro: 'Valor del Litro',
		adicionarValorAoContrato: 'Agregar valor al contrato',
		adicionarAditivo: 'Agregar aditivo',
		selecioneUmEmpenho: 'Seleccione un esfuerzo',
		numeroDoCe: 'Número de recibo de entrega',
		porcentagemConsumidaDoEmpenho: 'Porcentaje de esfuerzo consumido',
		consumidoOValorTotalDoEmpenho: 'La cantidad total de esfuerzo se consumió',
		valorNaoPermitidoPorUltrapassarOValorEmpenhado: 'Cantidad no permitida por exceder la cantidad de esfuerzo',
		entradaRegistrada: 'Entrada registrada',
		corrijaOsCamposEmVermelho: 'Corrija los campos en rojo',
		valorEmpenhado:'Valor Esforzado',
		porcentagemConsumidaDoContrato: 'Porcentaje consumido del contrato',
		consumidoOValorTotalDoContrato: 'La cantidad total del contrato se consumió',
		valorNaoPermitidoPorUltrapassarOValorContratado: 'Cantidad no permitida por exceder el valor contratado',
		gestaoDeContratos: 'Gestión de contratos',
		valoresDoContrato: 'Valores del contrato',
		aditivos: 'Adiciones',
		aditivo: 'Aditivo',
		valorDoContrato: 'Valor del contrato',
		valoresAtivos: 'Valores activos',
		desejaExcluirADocumentacao: 'Quieres borrar la documentación',
		documentacaoExcluidaComSucesso: 'Documentación eliminada correctamente',
		desativarTodasInspecoes: 'Para deshabilitar todas las inspecciones, se requiere una justificación',
		desativarInspecoes: 'Para deshabilitar esta inspección, se requiere una justificación',
		ativarTodasInspecoes: 'Para activar todas las inspecciones, se requiere una justificación',
		ativarInspecoes: 'Para activar esta inspección, se requiere una justificación',
		habilitarInspecao: 'Habilitar inspección',
		desabilitarInspecao: 'Desactivar inspección',
		adicionarFrequencia: 'Agregar frecuencia',
		capacidade: 'Capacidad',
		quantitativo: 'Cuantitativo',
		desejaExcluirEsseTipo: '¿Quieres eliminar este Tipo?', 
		vidaUtil: 'Esperanza de vida',
		volumeAtual: 'Volumen actual',
		desejaExcluir: 'Quieres borrar',
		tipoUnidadeArmazenamento: 'Tipo Unidad Almacenamiento',
		monitora: 'Monitora',
		veiculo: 'Vehículo', 
		quantidadeAtual: 'Cantidad Actual', 
		capacidadeMaxima: 'Maxima Capacidad',
		icone: 'Icono', 
		cep: 'Código Postal', 
		logradouro: 'Dirección',
		complemento: 'Complemento',
		contato: 'Contacto',
		cadastroTipoArmazenamento: 'Registro Tipo Almacenamiento',
		descricaoTipoArmazenamento: 'Descripción Tipo Almacenamiento',
		inspecaoExcluidaComSucesso: 'Inspección eliminada correctamente',
		mecanicoResponsavel: 'Mecánico Responsable',
		inspetorResponsavel: 'Inspector Responsable',
		tarefaCadastrada: 'Tarea Registrada',
		tarefaAdicionada: 'Tarea Agregada',
		servicosAExecutar: 'Servicios a ejecutar',
		servicosExecutados: 'Servicios desempeñados',
		itemAtualizado: 'Elemento actualizado',
		entradaEfetuada: 'Registrado',
		adicionarTarefas: 'Agregar Tareas',
		adicionarTarefa: 'Agregar Tarea',
		carregandoMovimentacoes: 'Cargar unidades',
		digiteOItemQueDesejaBuscar: 'Ingrese el artículo que desea buscar',
		atualizandoLista: 'Actualizando lista',
		naoFoiPossivelAssinar: 'No se pudo suscribir',
		naoFoiPossivelAssinarOS: 'No se puede firmar la Orden de Servicio',
		aTarefaFoiSalvaComSucesso: 'La tarea se ha guardado correctamente',
		asTarefasForamSalvasComSucesso: 'Las tareas se han guardado correctamente',
		aTarefaFoiAdicionadaComSucesso: 'La tarea se agregó correctamente',
		asTarefasForamAdicionadasComSucesso: 'Las tareas se han agregado correctamente',
		naoHaNenhumaTarefaCadastrada: 'No hay tarea registrada',
		naoFoiPossivelCancelar: 'No se puede cancelar',
		confirmar: 'Confirmar',
		unidadeOrgaoApoiado: 'Unidad de Apoyo de Órganos',
		cadastroDeVeiculos: 'Registro de Vehículo',
		veiculoExcluidoComSucesso: 'Vehículo eliminado correctamente',
		placa: 'Placa',
		prefixoOuIdentificacao: 'Prefijo/Identificación',
		prefixoOuIdentificacaoDoVeiculo: 'Prefijo / Identificación del vehículo',
		especieOuTipo:'Especies/Tipo',
		codigoRenavan: 'Código Renavan',
		chassi: 'Chasis',
		corPredominante: 'Color Predominante',
		marcaOuModelo: 'Marca / Modelo',
		anoFabricacao: 'Ano de Produção',
		anoModelo: 'Año Modelo',
		capacidadeOuPotenciaOuCilindrada:'Capacidad / Potencia / Capacidad del Cilindro',
		podeSerAlocado: 'Permiso de Asignación',
		numeroPatrimonio: 'Número de Capital',
		radio: 'Radio',
		kmAtual: 'Km Actual',
		validade: 'Duracion',
		alerta: 'Alerta',
		inspecaoAdicionadaComSucesso: 'Inspección agregada con éxito'
	},

	menuMatricula: {
		exibirMatricula: 'Ver la matrícula',
		candidadoEstrangeiro: 'Candidato Extranjero?',
		documentacaoApresentada: 'Documentación presentada (Candidatos)',
		cartaoIdentidade: 'Tarjeta de Identidad',
		cpf: 'RUC',
		tituloEleitor: 'Título de elector',
		certidaoCapacidadeFisisca: 'Certificado de Capacidad Física',
		certidaoEscolaridade: 'Certificado de Escolaridad',
		atestadoBonsAntecedentes: 'Certificado de Boa Conduta',
		casoPossuaLicenca: 'Si tiene licencia',
		documentacaoApresentadaEstrangeiros: 'Documentación presentada (Candidatos Extranjeros)',
		requerimentoDoCantidado: 'Solicitud del Candidato',
		copiaDocumentoViagem: 'Copia del documento de viaje',
		carteriaIdentidadeEstrangeirosValidade: 'Carnet de identidad para extranjeros con validez de permanencia',
		copiaCertificadoEscolaridadeEstrangeiro:
			'Copia del certificado de escolaridad (traducido oficialmente) de la enseñanza fundamental',
		copiaLicencaAtividade: 'Copia de la licencia de la actividad específica o documento equivalente (traducido oficialmente)',
		permissaoResidencia: 'Permiso de residencia',
		declaracaoSubJudice: 'Declaración de la solicitud de que no se encuentra SUB-JUDICE',
		termoMatricula: 'Término de matrícula',
		termoTexto:
			'DECLARACIÓN DE QUE ESTE(A) ALUMNO(A) ENCUENTRA MATRICULADO (A) EN ESTE CURSO, A PARTIR DE <strong>{{dataMatricula}}</strong>, MÁTRICULA <STRONG>{{matricula}}</strong>, YA ESTO ENTREGAS LAS COPIAS DE LA DOCUMENTACIÓN EXIGIDA, ACOMPAÑADAS DE <STRONG>{{qtd4x4}}</STRONG> RETRATOS 3X4.',
		assinaturaAluno: 'FIRMA DEL ALUMNO(A)',
		responsavelMatricula: 'RESPONSABLE DE LA MATRÍCULA',
		informacoesMatricula: 'Información sobre la inscripción',
		matriculaSalva: 'Matrícula ¡Salva con éxito!',
		numeroMatricula: 'Número de matrícula',
		naoSalva: 'No Salva'
	},

	registroDadosVoo: {
		variaveisDeMonitoramento: 'SEGUIMIENTO DE VARIABLE',
		altitudeTerreno: 'Altitud Absoluta',
		altitudeVoo: 'Altitud de vuelo',
		alturaVoo: 'Altura del vuelo',
		velocidadeAeronave: 'Velocidad',
		proa: 'ARCO',
		pressaoOleo: 'La presión de aceite',
		turbina: 'Turbina',
		torque: 'Torque',
		altitudeAeronave: 'Aviones actitud',
		aceleracaoVertical: 'Aceleración vertical',
		visualizacaoInstrumentos: 'Vista de instrumentos',
		visualizacaoGraficos: 'Gráficos de visualización',
		variacaoTorque: 'Gama de par',
		pressaoDoOleoTurbina: 'Turbina de presión de aceite'
	},

	perfil: {
		perfilDoUsuario: 'Perfil de usuario',
		editarPerfil: 'Editar Perfil',
		novoPerfil: 'Perfil nueva',
		nomePerfil: 'Nombre de perfil',
		perfilAtualizado: 'Perfil actualizado',
		PerfilInserido: 'Perfil insertado',
		clickEmNovo: 'Haga clic en \'Nuevo\''
	},

	conversao: {
		dia: 'día',
		mes: 'mes',
		hora: 'hora',
		ano: 'año',
		ciclo: 'ciclo',
		dias: 'días',
		meses: 'meses',
		horas: 'horas',
		anos: 'años',
		ciclos: 'ciclos'
	},

	pais: {
		brasil: 'Portugués',
		eua: 'Inglés',
		paraguai: 'Español',
		frances: 'francés',
		alemao: 'alemán',
		italiano: 'Italiano',
		espanhol: 'Español',
		portugues: 'Portugués',
		ingles: 'Inglés'
	},

	uploadfile: {
		download: 'Descargar',
		extPermitidas: 'Extensiones permitidas',
		tituloForm: 'Anexar Archivo',
		erroMSG: 'No se permite este tipo de archivo',
		foto: 'Foto'
	},

	calendario: {
		hoje: 'Hoy',
		domingo: 'domingo',
		segundaFeira: 'lunes',
		terçaFeira: 'martes',
		quartaFeira: 'miércoles',
		quintaFeira: 'jueves',
		sextaFeira: 'viernes',
		sábado: 'sábado'
	},

	login: {
		entrar: 'Entrar',
		digiteLogin: 'Digite su nombre de usuario',
		digiteSenha: 'Digite su contraseña',
		textoErro: 'Usuario o contraseña no válidos',
		entrando: 'Entrando'
	},

	menuSolicitaApoio: {
		destino: 'Destino',
		partida: 'Salida',
		menuDataEfim: 'La fecha de inicio y fin son obligatorias',
		solicitaApoio: 'Solicitud',
		apoioAereo: 'Apoyo aéreo',
		menuNovaSolicitacao: 'Nueva Solicitud',
		menuSolicitaNova: 'Nueva',
		menuSolicitacao: 'Solicitud',
		menuCargo: 'Cargo',
		menuLocalOperacao: 'Lugar de Operación',
		menuCoordenador: 'Coordinador Suelo',
		menuCoordenadorSolo: 'Coordinador Suelo',
		menuMissaoApoio: 'Misión de Apoyo',
		menuOrgaoSolicitante: 'Organización Solicitante',
		menuEscolha: 'Elección',
		menuNomeOperacao: 'Nombre de la Operación',
		menuInicioOperacao: 'Fecha Inicio Operación',
		menuFimOperacao: 'Fecha Fin Operación',
		menuGrauPrioridade: 'Grado de prioridad',
		menuTipoOcorrencia: 'Tipo de Ocurrencia',
		codigoPnapa: 'Código Pnapa',
		naturezaEtipo: 'Ud. debe ingresar al menos una Naturaleza y Tipo.',
		escolhaArquivo: 'Escoja un archivo y haga clic en cargar.',
		corrigirCampos: 'Por favor, corrija los campos en rojo arriba.',
		escolherLocal: 'Debe escoger al menos un lugar.',
		novaOrdemMissao: 'Nueva Orden de Misión',
		ordemMissaoInserida: 'Nueva Orden de Misión insertada con éxito.',
		solicitacaoAtualizada: 'Solicitud actualizada con éxito.',
		solicitacaoAdicionada: 'Solicitud agregada con éxito.',
		statusAtualizado: 'Estado actualizado con éxito.',
		removidos: 'Todos eliminados.',
		dadosAtualizados: '¡Datos actualizados con éxito!'
	},

	gestao: {
		gestaoDe: 'Gestión'
	},

	menuVoo: {
		menuVvoo: 'T Vuelo',
		menuVtdesc: 'T Vuelo Décimo',
		menuVescolha: 'Escoja la aeronave para cargar los días volados.',
		menuVaeronave: 'Aeronave:',
		menuVatualizaTrechos: 'Actualizar Tramos',
		menuVatualizaTrechos2:
			'Al actualizar los tramos, el sistema buscará todos los tramos del día y los incluirá en el informe de vuelo. Tramos alterados se mantendrán.',
		menuVfechaRelatorio: 'Fecha Informe',
		menuVreabreRelatorio: 'Reabrir Informe',
		menuVestadoAlagoas: 'Estado de Alagoas',
		menuVssp: 'SSP',
		menuVcaesp: 'CAESP',
		menuVrelatorio: 'Informe de Vuelo',
		menuVnumRelatorio: 'Informe N°:',
		menuVcontato: 'Contacto:',
		menuVchefeCaesp: 'Jefe de la CAESP: 98884-7133',
		menuVchefeOp: 'Jefe de Operaciones: 98824-9657',
		menuVbaseMaceio: 'Base Maceió:4009-2040',
		menuVbaseArapiraca: 'Base Arapiraca: 3530-3518',
		menuVprefixo: 'Prefijo',
		menuVmodelo: 'Modelo',
		menuVtrechos: 'Tramos',
		menuVnum: 'N°',
		menuVde: 'De',
		menuVpara: 'Para',
		menuVcorte: 'Corte',
		menuVpartida: 'Partida',
		menuVtvoo: 'T Vuelo',
		menuVtdec: 'T Vuelo Dec',
		menuVpousos: 'Aterrizajes',
		menuVcomb: 'Comb.',
		menuVpax: 'Pax.',
		menuVtotal: 'Total',
		menuVhistorico: 'Histórico de los extractos',
		menuVtipoMissao: 'Tipo de Misión',
		menuVmissao: 'Misión',
		menuVcodigo: 'Código',
		menuVaerotatico: 'Ope. Aerotáctica/ Sup. Médico',
		menuVocorrencia: 'Ocurrencia:',
		menuVmapa: 'Mapas de los Tramos',
		menuVnumTrecho: 'Tramos N°',
		menuVsemMapa: 'No se encuentra map.a',
		menuVerroVoos: 'Error al cargar los vuelos del mes.'
	},

	menuOrdemMissao: {
		menuOrdem: 'Orden',
		menuMissao: 'Misión',
		menuOrdemmissao: 'Orden Misión:',
		menuNova: 'Nueva',
		menuNovaOrdem: 'Nueva Orden',
		menuOrdemSolicitacao: 'Solicitud',
		menuOrdemEscolha: 'Elección'
	},

	menuMonitoramento: {
		menuMonitora: 'Monitoreo',
		menuTempoReal: 'Tiempo Real',
		menuMonitoraAeronaves: 'Aeronaves',
		menuAeronaveNaoVoou: 'La aeronave aún no vuela hoy.',
		horaMes: 'Hora/Mes',
		horaDia: 'Hora/Día',
		voosDia: 'Vuelos del día',
		nenhumaManutencao: 'No hay mantenimientos programados.',
		totalCiclosVoadios: 'Total de ciclos volados'
	},

	menuRastreamento: {
		menuRastrea: 'Seguimiento',
		menuRastreaAeronave: 'Aeronave',
		menuRmudar: 'Cambiar',
		menuRtotal: 'Total'
	},

	menuRGhorasVoadas: {
		menuRGaeronave: 'Aeronave',
		menuRGdataInicio: 'Fecha Inicio',
		menuRGdataFim: 'Fecha Fin',
		menuRGou: 'O',
		menuRGrelatorio:
			'Este informe tiene fines operacionales, pudiendo generar diferencias de más o de menos en el total de las horas voladas cuando se compara con la bitácora.',
		menuRGhorasReportadas: 'Horas Reportadas'
	},

	menuRGestatisticaVoo: {
		menuAeronave: 'Aeronave'
	},

	menuRGoperacoes: {
		menuAeronave: 'Aeronave',
		menuTipo: 'Tipo',
		menuRelatorioOp: 'Informe de Operaciones',
		menuRGtipo: 'Tipo',
		menuRGde: 'De',
		menuRGpara: 'Para',
		menuRGpartida: 'Partida',
		menuRGtvoo: 'T Vuelo',
		menuRGtdec: 'T Dec',
		menuRGpousos: 'Aterrizajes',
		menuRGcomb: 'Comb.',
		menuRGpax: 'Pasajeros'
	},

	menuRGsolicitacoes: {
		menuRGrSolicitacoes: 'Informe de Solicitudes',
		menuRGnome: 'Nombre:',
		menuRGprioridade: 'Prioridad:',
		menuRGorgao: 'Organización:',
		menuRGsemdados: 'No se encuentran datos.',
		menuRGoperacao: 'Operación:',
		menuRGsolicitacao: 'Solicitudes'
	},

	menuRGordemmissao: {
		menuOMnome: 'Nombre:',
		menuOMprioridade: 'Prioridad:',
		menuOMorgao: 'Organización:',
		menuOMsemdados: 'No se encuentran datos.',
		menuOMoperacao: 'Operación:',
		menuOMmissao: 'Orden de Misión',
		menuOMcoordenador: 'Coordinador:',
		menuOMtripulantes: 'Tripulantes:',
		menuOMlotacao: 'Capacidad:',
		menuOMemail: 'Correo electrónico:',
		menuOMtelefone: 'Teléfono:',
		menuOMcargo: 'Cargo:',
		menuOMinicio: 'Inicio',
		menuOMfim: 'Fin',
		menuOMnaoDisponivel: 'No disponible en este momento.',
		menuOMguarnicao: 'Guarnición Aérea:',
		menuOMadicionados: 'Agregados:',
		menuOMenviar: 'Enviar y guardar',
		menuOMdataInicio: 'El período de Orden de Misión debe estar entre el período de la Solicitud.',
		menuOMescolha: 'Elección',
		menuOMdataMaior: 'La fecha inicial no puede ser mayor que la fecha final.',
		menuOMordemAtualizada: 'Orden actualizada con éxito.',
		menuOMordemAdicionada: 'Orden agregada con éxito.',
		menuOMordemEncerrada: 'Orden terminada con éxito.'
	},

	menuAGnovoOrgao: {
		cadOrgaoTitulo: 'Registro del Órgano',
		menuAGcadOrgao: 'Nuovo Órgano',
		menuAGdescOrgao: 'Descripción',
		menuAGdescOrgao2: 'Descripción del órgano',
		menuAGeditOrgao: 'Editar Órgano',
		menuAGtextoG1: 'Clic en \'Nuevo\'',
		menuAGtextoG2: 'Clic en el icono',
		menuAGtextoG3: ' na lista opuesta.',
		menuAGattOrgao: 'Órgano actualizado',
		menuAGaddOrgao: 'Órgano insertado'
	},

	menuAGnovoCargo: {
		menuAGcadCargo: 'Nuevo Cargo',
		menuAGdescCargo: 'Descripción',
		menuAGdescCargo2: 'Descripción del trabajo',
		menuAGeditCargo: 'Editar Cargo',
		menuAGtexto1: 'Clic en \'Nuevo\'',
		menuAGtexto2: 'Clic en el icono',
		menuAGtexto3: ' na lista opuesta.',
		menuAGattCargo: 'Cargo actualizado',
		menuAGaddCargo: 'Cargo insertado',
		menuAGcadCargo2: 'Registro de cargo'
	},

	menuAGnovoGrupo: {
		naturezaManutencao: 'Naturaleza De Mantenimiento',
		cadGrupoTitulo: 'Grupo de Inspección',
		menuAGcadGrupo: 'Nuevo Grupo',
		menuAGdescGrupo: 'Descripción',
		menuAGdescGrupo2: 'Descripción del grupo',
		menuAGeditGrupo: 'Editar',
		menuAGtextoG1: 'Clic en \'Nuevo\'',
		menuAGtextoG2: 'Clic en el icono',
		menuAGtextoG3: ' na lista opuesta.',
		menuAGattGrupo: 'Grupo actualizado',
		menuAGaddGrupo: 'Grupo insertado'
	},

	menuAGstatus: {
		cadStatusTitulo: 'Registro de Estado',
		menuAGcadStatus: 'Nuevo Estado',
		menuAGcadStatus2: 'Registrar estado',
		menuAGdescStatus: 'Descripción',
		menuAGeditStatus: 'Editar estado',
		menuAGdescStatus2: 'Descripción del estado',
		menuAGattStatus: 'Estado actualizado',
		menuAGaddStatus: 'Estado  insertado',
		menuAGtexto1: 'Clic on \'Nuevo\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
		obrigaStatus: 'Requieren la introducción de una nota al seleccionar este estado?'
	},

	menuAGnovoPosto: {
		menuAGcadPosto: 'Nuevo Puesto',
		menuAGdescPosto: 'Descripción',
		menuAGdescPosto2: 'Descripción del trabajo',
		menuAGeditPosto: 'Editar Puesto',
		menuAGtexto1: 'Clic en \'Nuevo\'',
		menuAGtexto2: 'Clic en el icono',
		menuAGtexto3: ' la lista opuesta.',
		menuAGattPosto: 'Puesto actualizado',
		menuAGaddPosto: 'Puesto insertado'
	},

	menuAGnovoUsuario: {
		msgPrivilegio: 'Añadir quiere más privilegios?',
		pClasse: '1era Clase',
		sClasse: '2da Clase',
		tClasse: '3ra Clase',
		menuAGcadUser: 'Nuevo Usuario',
		menuAGnome: 'Nombre',
		menuAGcpf: 'Identidad',
		menuAGcelular: 'Celular',
		menuAGcargo2: 'Cargo',
		menuAGcadastroUsuario: 'Registro de usuarios',
		menuAGeditarUsuario: 'Editar usuario',
		menuAGdadosCadastrais: 'Datos de Registro',
		menuAGemail: 'Correo electrónico',
		menuAGtel1: 'Teléfono 1',
		menuAGtel2: 'Teléfono 2',
		menuAGcel1: 'Celular 1',
		menuAGcel2: 'Celular 2',
		menuAGid: 'Identidad',
		menuAGorgao: 'Órgano',
		menuAGnumOrdem: 'Número de Orden',
		menuAGmatricula: 'Matrícula',
		menuAGnomeGuerra: 'Nombre de Guerra',
		menuAGposto: 'Puesto/Graduación',
		menuAGcep: 'CEP',
		menuAGlogradouro: 'Via Pública',
		menuAGnum: 'Número',
		menuAGcomplemento: 'Complemento',
		menuAGbairro: 'Barrio',
		menuAGcidade: 'Ciudad',
		menuAGestado: 'DPTO',
		menuAGguarnicao: '¿Forma parte de la guarnición?',
		menuAGsistema: '¿Tiene acceso al sistema?',
		menuAGsim: 'Sí',
		menuAGnao: 'No',
		menuAGacesso: 'Acceso al sistema',
		menuAGlogin: 'Nombre de Usuario',
		menuAGsenha: 'Contraseña',
		menuAGbranco: 'En blanco, mantener la misma contraseña.',
		menuAGdepto: 'Departamento',
		menuAGcargo: 'Cargo',
		menuAGprivilegio: 'Privilegios del Sistema',
		menuAGremover: 'Eliminar todos los privilegios',
		menuAGmarcarTodos: 'Marcar Todos',
		menuAGexcluir: 'Excluir usuario',
		menuAGdesejaExcluir: '¿Desea EXCLUIR este usuario?',
		menuAGanac: 'Código ANAC',
		menuAGtipo: 'Tipo',
		menuAGguarnicao2: 'Guarnición',
		menuAGtipoCertificado: 'Tipo Certificado',
		menuAGvalidadeCertificado: 'Validez Certificado',
		menuAGusuarioExcluido: 'Usuario eliminado con éxito.',
		menuAGusuarioAtualizado: 'Usuario actualizado con éxito.',
		menuAGusuarioAdicionado: 'Usuario agregado con éxito.'
	},

	menuAGinspecao: {
		menuAGtInspecao: 'Tipo',
		menuAGnInspecao: 'Naturaleza',
		menuAGmInspecao: 'Modelo',
		menuAGgInspecao: 'Grupo Inspección',
		menuAGiInspecao: 'Inspección',
		menuAGaAeronave: 'de Aeronaves',
		menuAGnovaInspecao: 'Nueva Inspección',
		menuAGeditarInspecao: 'Editar Inspección',
		menuAGdadosInspecao: 'Datos de Inspección',
		menuAGmodelAeronave: 'Modelo',
		menuAGiDescricao: 'Descripción',
		menuAGnumPeca: 'Número Parte',
		menuAGnumSerie: 'Número Serie',
		menuAGvidaUtil: 'Vida útil de la Inspección',
		menuAGiDias: 'Días',
		menuAGiMeses: 'Meses',
		menuAGiAnos: 'Años',
		menuAGiHoras: 'Horas',
		menuAGhHomem: 'Hora/Hombre',
		menuAGcCiclo: 'Ciclo',
		menuAGatualizado: 'Inspección actualizada con éxito.',
		menuAGinserido: 'Inspección insertada con éxito.',
		menuAGdescInspecao: 'Descripción de la inspección',
		menuAGtextoI1: 'Clic en \'Nueva Inspección\'',
		menuAGtextoI2: 'Clic en el ícono',
		menuAGtextoI3: ' na lista opuesta lado.'
	},

	menuEscala: {
		tripulanteOperacional: 'Tripulante Operacional',
		radioOperador: 'Operador de radio',
		menuCarregaEscala: 'Cargando escala',
		menuSalvaEscala: 'Guardado',
		pilotos: 'Pilotos',
		copilotos: 'Copilotos',
		menuRemover: 'Eliminar',
		pilotoEcopiloto: 'Piloto y Copiloto',
		sessaoManutencao: 'Sesión de Mantenimiento',
		secaoManutencao: 'Sección de Mantenimiento',
		tripulanteArapiraca: 'Tripulante Arapiraca',
		tripulanteMaceio: 'Tripulante Maceió',
		menuEtotalDia: 'Total de servicios por día',
		menuElegenda: 'Subtítulo',
		menuEvermelho: 'Corrija los campos en rojo.'
	},

	menuArapiraca: {
		menuAescala: 'Cargando escala Arapicara',
		menuAsalvo: 'Guardado',
		menuAnpg: 'Nombre- Post/Grad'
	},

	menuMaceio: {
		menuMmaceio: 'Cargando escala Maceió',
		menuMsalvo: 'Guardado',
		menuMnpg: 'Nombre- Post/Grad',
		menuMtripulante: 'Tripulante ya agregado'
	},

	menuTripOperacional: {
		carregando: 'Cargando escala operacional',
		escalaD: 'D - NORMAL',
		escalaS: 'S - GUARDIA',
		escalaE: 'E - EXPEDIENTE'
	},

	menuOpRadio: {
		carregando: 'Cargando escala rádio operador'
	},

	menuErro: {
		menuTextoErro: '¿Ocurrió algún error al intentar realizar esta acción?',
		menuTextoErro2: 'Algo me dice que no puede hacerlo.',
		menuEtitulo: '¡Ups!',
		menuEtitulo2: '¡Oh-o!'
	},

	menuManutencao: {
		menuTipo: 'Tipo',
		menuNivel: 'Nivel',
		menuMapu: 'APU',
		menuMtecnico: 'Técnico de mantenimiento',
		menuMtotal: 'Total',
		menuMapoio: 'Apoyo Suelo',
		menuMctm: 'C T M',
		menuMf: 'V - VACACIONES',
		menuMx: 'X - ESTÁ ESCALADO',
		menuMeventos: 'Eventos',
		menuMdescricao: 'Descripción',
		menuMhHomemHora: 'Hombres/Hora',
		menuMdataPrevista: 'Fecha Prevista',
		menuMdisponibilidade: 'Disponibilidad',
		menuMhorasTotais: 'Horas Totales',
		menuMdetalhes: 'Actualizar',
		menuMhorasAtuais: 'Horas Actuales',
		menuMrevalidaC: 'Revalidaciones y Certificaciones',
		menuMinspReg: 'Inspecciones Reglamentarias',
		menuMinspProg: 'Inspecciones Programadas',
		menuMcontrolComp: 'Control de Componentes',
		menuMinspProgEquip: 'Inspecciones Programadas de Equipamientos',
		menuMcelula: 'Célula',
		menuMmotor: 'Motor',
		menuMmodelo: 'Modelo',
		menuMcodinome: 'Nombre código',
		menuMnumSerie: 'Número Serie',
		menuMhrsAtuais: 'Horas Actuales',
		menuMpousosAtuais: 'Aterrizajes Actuales',
		menuMciclosNG: 'Ciclos NG',
		menuMciclosT1: 'Ciclos NF',
		menuMciclon1: 'Ciclos N1',
		menuMciclon2: 'Ciclos N2',
		menuMatualizaManutencao: 'Actualizar Mantenimiento',
		menuMescolha: 'Escoja una opción',
		menuMinspProgDE: 'Inspecciones programadas de',
		menuMcontrolCompDE: 'Control de componentes de',
		menuMatualizada: 'Mantenimiento actualizado con éxito'
	},

	menuAGnovaEscala: {
		menuAGtipoEscala: 'Tipo',
		menuAGbusca: 'Búsqueda',
		menuAGcarregar: 'Cargar'
	},

	menuAGplanoManutencao: {
		menuAGInspecaoAtualizada: 'Inspecciones actualizadas.',
		menuAGplano: 'Plan de Mantenimiento',
		menuAGinspecao: 'Inspección',
		menuAGperiodicidade: 'Periodicidad',
		menuAGpeca: 'Parte',
		menuAGserie: 'Serie',
		menuAGdetalhes: 'Detalles',
		menuAGaddInspecao: 'Agregar Inspección al Plan',
		menuAGinspDetalhe: 'Detalles de la Inspección',
		menuAGcelula: 'Célula',
		menuAGmotor: 'Motor',
		menuAGinspecoes: 'Inspección',
		menuAGaddTodas: 'Agregar Todas',
		menuAGremoveTodas: 'Eliminar Todas',
		menuAGmodelo: 'Modelo',
		manuAGNenhumaEncontrada: 'No se encontraron inspecciones.',
		revalidacoes: 'REVALIDACIONES Y CERTIFICACIONES',
		inspecoesRegulamentares: 'INSPECCIONES REGLAMENTARIAS',
		inspecoesProgramadas: 'INSPECCIONES PROGRAMADAS',
		controleDeComponentesCeula: 'CONTROL DE COMPONENTES',
		comprimentoDeBoletins: 'CUMPLIMIENTO DE BOLETINES DE AERONAVEGABILIDAD',
		comprimentodeBoletinsServico: 'CUMPLIMIENTO DE BOLETINES DE SERVICIOS',
		inspecoesProgramadasEquipamento: 'INSPECCIONES PROGRAMADAS DE EQUIPAMIENTOS',
		inspecoesProgramadasMotor: 'INSPECCIONES PROGRAMADAS',
		controleDeComponentesMotor: 'CONTROL DE COMPONENTES',
		inspecoesAcessoriosMotor: 'INSPECCIONES PROGRAMADAS DE ACCESORIOS'
	},

	menuAGprevencao: {
		menuAGNovaPrevencao: 'Nueva Prevención',
		menuAGconclusao: 'Descripción de la conclusión',
		menuAGconcluir: 'Concluir prevención',
		menuAGdataOcorrencia: 'Fecha de la Ocurrencia:',
		menuAGlocal: 'Lugar de la Ocurrencia:',
		menuAGcidade: 'Ciudad:',
		menuAGcidade2: 'Ciudad',
		menuAGaeronave: 'Aeronave:',
		menuAGaeronave2: 'Aeronave',
		menuAGenvolvidos: 'Personal Involucrado:',
		menuAGdescricao: 'Descripción:',
		menuAGrelator: 'Relator:',
		menuAGemail: 'Correo electrónico:',
		menuAGpPrevencao: 'Prevención',
		menuAGrelatorioAdicionado: 'Informe agregado con éxito.',
		menuAGprevencaoConcluida: 'Prevención concluída.',
		menuAGrelatoOcorrencia:
			'El informe de la ocurrencia aquí presentada tiene como única finalidad el incentivo a la seguridad operacional, por lo cual su uso se destina exclusivamente a la prevención de accidentes. NO ES NECESARIO FIRMAR O IDENTIFICARSE',
		menuAGrelatorio: 'Informe de Prevención',
		menuAGrelato: 'Informe de Prevención'
	},

	menuAGcadAluno: {
		requisitosParaOcurso: 'Requisitos para este curso.',
		eulieaceitootermo: 'He leído y estoy de acuerdo con los términos anteriores.',
		paraPortadoresDeLicenca: 'Para los Portadores de licencias',
		inscricaoSalva: 'La inscripción se salva con éxito!',
		numeroInscricao: 'Número de la inscripción',
		voltarParaLista: 'Volver a la lista',
		sebrac: 'SEBRAC',
		menuAGalunoInscs: 'Inscripciones',
		menuAGalunoAdm: 'Administración',
		menuAGalunoEscolar: 'Escolar',
		menuAGalunoNovaInsc: 'Nueva Inscripción',
		menuAGalunoInsc: 'Inscripción',
		menuAGalunoDoc: 'Documento',
		menuAGalunoFicha: 'Ficha de Inscripción',
		menuAGalunoSexo: 'Sexo',
		pilotoPPaviao: 'Piloto Privado de Avión - Práctico',
		pilotoPTaviao: 'Piloto Privado de Avión - Teórico',
		pilotoCPaviao: 'Piloto Comercial de Avión - Práctico',
		pilotoCTaviao: 'Piloto Comercial de Avión - Teórico',
		pilotoPPhelicoptero: 'Piloto Privado de Helicóptero - Práctico',
		pilotoPThelicoptero: 'Piloto Privado de Helicóptero - Teórico',
		pilotoCPhelicoptero: 'Piloto Comercial de Helicóptero - Práctico',
		pilotoCThelicoptero: 'Piloto Comercial de Helicóptero - Teórico',
		habIFRhelicopteroP: 'Habilitação IFR Helicóptero - Prático',
		habIFRhelicopteroT: 'Habilitação IFR Helicóptero - Teórico',
		habIFRaviaoP: 'Habilitación IFR Avión - Práctico',
		habIFRaviaoT: 'Habilitación IFR Avión - Teórico',
		simuladorVoo: 'Simulador de vuelo',
		habilitacao: 'Para los Portadores de Habilitación',
		dadosPessoais: 'Datos Personales',
		contato1: 'Teléfono Principal',
		contato2: 'Teléfono Celular',
		contato3: 'Contacto 3',
		empresa: 'Empresa',
		nomeEmpresa: 'Nombre de la Empresa',
		menuAGalunoCargo: 'Cargo',
		filiacao: 'Afiliación',
		nomeMae: 'Nombre de la Madre',
		nomePai: 'Nome del Padre',
		documentacao: 'Documentación',

		docIdentidade: 'Identidad',
		docOrgaoExpeditor: 'Órgano Expedidor',
		docDataExpedicao: 'Fecha de emisión',
		docCic: 'RUC',
		docCertidaoDeReservista: 'Certificado de Reservista',
		docCategoria: 'Categoría',
		docTituloEleitor: 'Título de elector',
		docZona: 'Zona',
		doSecao: 'Sección',

		doc1: 'Documento 1',
		doc2: 'Documento 2',
		doc3: 'Documento 3',
		nivelInstrucao: 'Nível de Instrucción',
		escolhaNivelInstrucao: 'Eligir su nivel de instrucción',
		superiorCompleto: 'Superior',
		ensinoFundamental: 'Escuela',
		ensinoMedio: 'Bachillerato',

		mestrado: 'Máster',
		doutorado: 'Doctorado',
		curso: 'Curso',
		idiomasEstrangeiros: 'Idiomas Extranjeros',
		idioma: 'Idioma',
		le: 'Lee',
		escreve: 'Escribió',
		fala: 'Habla',
		entende: 'Entiende',
		infoAdicionais: 'Informaciones adicionales',
		tipoSanguineo: 'Tipo Sanguíneo',
		fatorRH: 'Factor RH',
		alergico: 'Es alérgico a algún tipo de medicamentos (s)? Describirlo (s)',
		acidente: 'En caso de accidente avisar a la',
		grauParentesco: 'Grado de parentezco',
		outrasInfo: 'Otras Informaciones'
	},

	menuAGcadCurso: {
		cadCursoTitulo: 'Cursos',
		cadCursoSecretaria: 'Escuela de vuelo',
		cadNovoCurso: 'Nuevo Curso',
		cadEditarCurso: 'Editar Curso',
		cadNomeCurso: 'Nombre del Curso',
		cadCursoPratico: 'Práctico',
		cadCursoTeorico: 'Teórico',
		cadCursoCargaHoraria: 'Carga Horaria',
		cadValorCurso: 'Valor del Curso',
		cadCursoDisciplina: 'Disciplinas',
		cadCursoNovaDisciplina: 'Insertar Nueva Disciplina',
		cadCursoCliente: 'Clic en el \'Nuevo',
		cadCursoSucesso: 'Curso Insertado',
		cadCursomenuMtexto2: 'clic en el ícono',
		cadCursomenuMtexto3: 'na lista opuesta.',
		cadCursoAtualizado: 'Curso actualizado'
	},

	menuCadPacote: {
		PacoteTitulo: 'Paquete',
		PacoteSecretaria: 'Escuela de vuelo',
		PacoteDescricao: 'Descripción',
		NovoPacote: 'Nuevo Paquete',
		EditarPacote: 'Editar Paquete',
		PacotePratico: 'Práctico',
		PacoteTeorico: 'Teórico',
		PacoteNumeroHoras: 'Carga Horario',
		ValorPacote: 'Valor del Paquete',
		PacoteCliente: 'Clic en el \'Novo\'',
		PacoteTexto1: 'clic en el ícono',
		PacoteTexto2: 'na lista opuesta.',
		PacoteSucesso: 'Paquete Insertado',
		PacoteAtualizado: 'Paquete actualizado'
	},

	menuCadHabilitacao: {
		HabiTitulo: 'Habilitación',
		HabiSecretaria: 'Escuela de vuelo',
		HabiDescricao: 'Descripción',
		NovoHabi: 'Nuevo Habilitación',
		EditarHabi: 'Editar Habilitación',
		HabiCliente: 'Clic en el \'Novo\'',
		HabiTexto1: 'clic en el ícono',
		HabiTexto2: 'na lista opuesta.',
		HabiSucesso: 'Habilitación Insertado',
		HabiAtualizado: 'Habilitación Actualizado'
	},

	menuAGcadMatricula: {
		cadMatriculaTitulo: 'Matrícula',
		cadNovaMatricula: 'Nueva Matrícula',
		cadNumero: 'Número',
		cadNomeAluno: 'Nombre del Alumno',
		cadCurso: 'Curso',
		cadHabilitacao: 'Habilitación',
		attMatricula: 'Matrícula actualizada',
		addMatricula: 'Matrícula insertada',
		fechaMatricula: 'Matrícula encerrada'
	},

	menuAGcadPagamento: {
		cadPagamentoTitulo: 'Pagamento',
		cadNovoPagamento: 'Nuevo Pagamento',
		cursoHab: 'Curso',
		nomeAluno: 'Nombre - Alumno',
		cadValor: 'Valor',
		codigoPagamento: 'Código',
		addPagamento: 'Pagamento insertado',
		attPagamento: 'Pagamento actualizado',
		fechaPagamento: 'Pagamento encerrado'
	},

	menuAGpermutas: {
		menuAGsecretariaAlagoas: 'Secretaría de Estado de Seguridad Pública de Alagoas',
		menuAGchefiaEspecial: 'Jefatura Especial del Área de Seguridad Pública – CAESP',
		menuAGsalvo: '¡Guardado con éxito!',
		menuAGcidade: 'Ciudad:',
		menuAGestado: 'DPTO:',
		menuAGlocal: 'Lugar:',
		menuAGdata: 'Fecha:',
		menuAGenvolvidos: 'Involucrados:',
		menuAGaeronave: 'Aeronave involucrada:',
		menuAGsituacao: 'Situación:',
		menuAGconclusao: 'Conclusión',
		menuAGnome: 'Nombre:',
		menuAGemail: 'Correo electrónico:',
		menuAGtel: 'Teléfono:',
		menuAGtipo: 'Tipo:',
		menuAGtipo2: 'Tipo',
		menuAGinicio: 'Inicio',
		menuAGfim: 'Fin',
		menuAGsolicitado: 'Solicitado',
		menuAGresposta: 'Respuesta:',
		menuAGresposta2: 'Respuesta'
	},

	menuAGtipoAfastamento: {
		cadAfastamentoTitulo: 'Aclaramiento de registro',
		menuAGcadAfastamento: 'Nuevo Aclaramiento',
		menuAGdescAfastamento: 'Descripción',
		menuAGdescAfastamento2: 'Descripción del aclaramiento',
		menuAGeditAfastamento: 'Editar Aclaramiento',
		menuAGtextoG1: 'Clic en \'Nuevo\'',
		menuAGtextoG2: 'Clic en el ícono',
		menuAGtextoG3: ' na lista opuesta.',
		menuAGattAfastamento: 'Aclaramiento actualizado',
		menuAGaddAfastamento: 'Aclaramiento insertado'
	},

	menuAGtipoMissao: {
		cadMissaoTitulo: 'Registro de Tipo de Misión',
		menuAGcadMissao: 'Nueva Misión',
		menuAGdescMissao: 'Descripción',
		menuAGdescMissao2: 'Descripción de la misión',
		menuAGeditMissao: 'Editar Misión',
		menuAGtexto1: 'Clic en \'Nueva\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
		menuAGattMissao: 'Misión actualizada',
		menuAGaddMissao: 'Misión insertada'
	},

	menuAGtipoOcorrencia: {
		cadOcorrenciaTitulo: 'Registro de Tipo de Ocurrencia',
		menuAGcadOcorrencia: 'Nueva Ocurrencia',
		menuAGdescOcorrencia: 'Descripción',
		menuAGdescOcorrencia2: 'Descripción da ocurrencia',
		menuAGeditOcorrencia: 'Editar Ocurrencia',
		menuAGtexto1: 'Clic en \'Nova\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
		menuAGattOcorrencia: 'Ocurrencia actualizada',
		menuAGaddOcorrencia: 'Ocurrencia insertada'
	},

	menuAGtipoPrioridade: {
		cadPrioridadeTitulo: 'Registro de Tipo de Prioridad',
		menuAGcadPrioridade: 'Nueva Prioridad',
		menuAGdescPrioridade: 'Descripción',
		menuAGdescPrioridade2: 'Descripción de Prioridad',
		menuAGeditPrioridade: 'Editar Prioridad',
		menuAGtexto1: 'Clic en \'Nueva\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
		menuAGattPrioridade: 'Prioridad actualizada',
		menuAGaddPrioridade: 'Prioridad insertada'
	},

	menuAGtipoGuarnicao: {
		cadGuarnicaoTitulo: 'Registro de Tipo de Guarnición',
		menuAGcadGuarnicao: 'Nueva Guarnición',
		menuAGdescGuarnicao: 'Descripción',
		menuAGdescGuarnicao2: 'Descripción de la guarnición',
		menuAGgSigla: 'Acrónimo',
		menuAGgOrdem: 'Orden',
		menuAGeditGuarnição: 'Editar Guarnición',
		menuAGtextoG1: 'Clic en \'Nueva\'',
		menuAGtextoG2: 'Clic en el ícono',
		menuAGtextoG3: ' na lista opuesta.',
		menuAGattGuarnicao: 'Guarnición actualizada',
		menuAGaddGuarnicao: 'Guarnición insertada'
	},

	menuAGtipoNatureza: {
		cadNaturezaTitulo: 'La Naturaleza de Registro',
		menuAGcadNatureza: 'Nueva Naturaleza',
		menuAGdescNatureza: 'Descripción',
		menuAGdescNatureza2: 'Descripción de la naturaleza',
		menuAGnSigla: 'Acrónimo',
		menuAGeditNatureza: 'Editar Naturaleza',
		menuAGtexto1: 'Clic en \'Nueva\'',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
		menuAGattNatureza: 'Naturaleza actualizada',
		menuAGaddNatureza: 'Naturaleza insertada'
	},

	menuMoficina: {
		cadOficinaTitulo: 'Registro de Taller',
		menuMcadOficina: 'Nueva Taller',
		menuMtexto1: 'Clic en \'Nueva Taller\'',
		menuMtexto2: 'Clic en el ícono',
		menuMtexto3: ' na lista opuesta.',
		menuMresponsavel: 'Responsable',
		menuMeditOficina: 'Editar Taller',
		menuMaddOficina: 'Taller insertada',
		menuMattOficina: 'Taller actualizada'
	},

	menuMsolicitaManutencao: {
		menuMsolicitaInspecoes: 'Inspecciones',
		menuMsolicitaEvento: 'Evento',
		menuMsolicitaTipo: 'Tipo',
		menuMsolicitaModalidade: 'Modo',
		menuMsolicitaNivel: 'Nivel',
		menuMsolicitaHhora: 'Hombres Hora',
		menuMsolicitaDisponibilidade: 'Disponibilidad',
		menuMsolicitaProxInspecao: 'Siguiente inspección',
		menuMsolicitaMesesDias: 'Meses / Días',
		menuMsolicitaHtotais: 'Horas Totales',
		menuMsolicitaEscolha: 'Elija las inspecciones abajo',
		menuMsolicitaSelecione: 'Seleccione una o varias inspecciones a continuación y haga clic en AGREGAR',
		menuMsolicitaReferente: 'Solicitudes de aeronave',
		menuMsolicitaCancelar: '¿Desea cancelar esta solicitud de mantenimiento?',
		menuMsolicitaAdd: 'Solicitud de mantenimiento actualizada.',
		menuMsolicitaAtt: 'Solicitud de mantenimiento insertada.',
		menuMsolicitaManutencoes: 'Solicitudes de mantenimiento'
	},

	menuAfastamento: {
		menuAaprovar: 'Aprobar',
		menuAreprovar: 'Reprobar',
		tipo: 'Tipo:',
		menuAatualizado: 'Pedido actualizado con éxito.',
		menuAadicionado: 'Pedido agregado con éxito.'
	},

	menu: {
		sairSistema: '¿Desea salir del sistema?',
		administracao: 'Administración general',
		menuOrdem: 'Orden',
		menuMissao: 'Misión',
		menuRastreamento: 'Seguimiento',
		menuMonitoraAeronaves: 'Aeronaves',
		menuManutencao: 'Mantenimiento',
		menuManutencaoAeronave: 'Aeronave',
		menuRelatorios: 'Informes',
		menuGerenciais: 'Gerenciales',
		menuAdministracao: 'Administración',
		menuGeral: 'General',
		segurancaOperacional: 'Seguridad Operacional',
		segurancaOperacionalSeguranca: 'Seguridad',
		segurancaOperacionalOperacional: 'Operacional'
	},

	submenu: {
		ExtratoCompleto: 'Extracto Completo',
		ControleAtividadeAerea: 'Control de actividad aérea',
		aeronaves: 'Aeronaves',
		horasVoadas: 'Horas Voladas',
		mostradores: 'Monitores',
		telaCheia: 'Pantalla Completa',
		relatorioVoo: 'Informe de Vuelo',
		estatisticaVoo: 'Estadística de Vuelo',
		relatorioPrevencao: 'Informe de Prevención',
		relatorioOperacoes: 'Informe de Operaciones',
		relatorioSolicitacoes: 'Informe de solicitudes',
		cadUser: 'Registro de Usuario',
		cadEscala: 'Registro de Escalas',
		cadPrevencao: 'Registro de Prevención',
		permutas: 'Intercambios, Licencias Médicas y Liberaciones',
		subRelatorio: 'Informes',
		subSolicitacoes: 'Solicitudes',
		subRelatorioOrdem: 'Informe Orden',
		subOrdem: 'de Misión',
		cadCargo: 'Posteriores a su registro',
		cadPosto: 'Posteriores a su registro',
		cadastroGrupoInspecao: 'Register Grupo de Inspección',
		cadAcao: 'Tipo de acción de registro',
		cadAfastamento: 'Administrativo de declaración de registro',
		subAdministracao: 'Administración',
		subEscolar: 'Escolar',
		subEnsino: 'Ensino',
		subPagamentos: 'Pagamentos',
		subTurmas: 'Clases',
		inscricoesEMatricula: 'Inscripciones y matrículas',
		gestaoDoEnsino: 'Gestión de la Enseñanza',
		teoricoEPratico: 'Teórico y práctico',
		cadEvento: 'Registro de eventos',
		segurancaOperacionalRac: 'Informe de aviación civil (RAC)',
		segurancaOperacionalEso: 'Gestión de riesgos (ESO)',
		segurancaOperacionalRire: 'Informe inicial de respuesta de emergencia (RIRE)'
	},

	componentNatureza: {
		cNatureza: 'Naturaleza de la Ocurrencia',
		cTipo: 'Tipo de la Ocurrencia',
		cItem: 'No se ha agregado ningún ítem todavía',
		cAddItem: 'Ud. sólo puede agregar un ítem',
		cItemAdicionado: 'Ítems ya agregados',
		cItemJaAdicionado: 'Este ítem ya se agregó'
	},

	componentRAisp: {
		risp: 'Risp',
		aisp: 'Aisp'
	},

	nomesMes: {
		janeiro: 'Enero',
		fevereiro: 'Febrero',
		marco: 'Marzo',
		abril: 'Abril',
		maio: 'Mayo',
		junho: 'Junio',
		julho: 'Julio',
		agosto: 'Agosto',
		setembro: 'Septiembre',
		outubro: 'Octubre',
		novembro: 'Noviembre',
		dezembro: 'Diciembre'
	},

	diasSemana: {
		domingo: 'D',
		segunda: 'L',
		terca: 'M',
		quarta: 'M',
		quinta: 'J',
		sexta: 'V',
		sabado: 'S'
	},

	diasSemanaPos: {
		0: 'D',
		1: 'L',
		2: 'M',
		3: 'M',
		4: 'J',
		5: 'V',
		6: 'S'
	},

	cadAeronave: {
		novaAeronave: 'Nueva Aeronave',
		cadastroDeAeronave: 'Matricula de la Aeronave',
		dadosAeroanve: 'Datos de la aeronave',
		tailNumber: 'Prefijo',
		dadosMotor: 'Datos del metor',
		aviao: 'Avión',
		helicoptero: 'Helicóptero',
		prefixo: 'Prefijo',
		modelo: 'Modelo',
		codinome: 'Nombre en clave',
		imei: 'IMEI',
		registro: 'Registro',
		etiqueta: 'Etiqueta',
		horasVoadas: 'Horas de Vuelo',
		ciclosVoados: 'Ciclos Volados',
		dataFabricacao: 'Fecha de Fabricación',
		dataUltima: 'Fecha del último mantenimiento',
		pousos: 'Aterrizaje',
		serialNumber: 'Número de série',
		ciclosT1: 'Ciclos Volados NF',
		motor: 'Motor',
		modeloMotor: 'Modelo del Motor',
		serialNumberMotor: 'Número de série del motor',
		tipo: 'Tipo',
		msgAtualizada: 'Aviones actualizado correctamente.',
		msgInserida: 'La inspección ha añadido correctamente.'
	},
	menuMalha: {
		novaSemana: 'Agregar semana'
	},
	menuSegurancaOperacional: {
		situacaoRelatada: 'Situación reportada',
		numeroDocumentoOrigem: 'Documento fuente No.',
		codigoControleInterno: 'Código de control interno',
		dataDoOcorrido: 'Fecha de ocurrencia',
		horaDoOcorrido: 'Hora de ocurrencia',
		localDoOcorrido: 'Ubicación',
		organizacoesEnvolvidas: 'Organizaciones involucradas',
		descricaoEvento: 'Descripción del evento.',
		analiseInicial: 'Analisis inicial',
		probabilidade: 'Probabilidad de que vuelva a ocurrir ESO',
		severidade: 'Gravedad si ocurre la peor consecuencia posible de este evento',
		setoresResponsaveis: 'Sectores responsables de mitigación',
		tolerabilidade: 'Tolerabilidad',
		respostaEnviadaAoRelator: 'Respuesta enviada al ponente?',
		analiseEvento: 'Análisis de eventos',
		acaoesMitigadoras: 'Acciones mitigantes',
		fatoresContribuintes: 'Factores contribuyentes',
		acoesForamSuficienteFinal: 'Fueron suficientes acciones de mitigación?',
		motivosAcoesNaoSuficiente: 'Razones de no suficiencia',
		quaisAcoesAdicionaisAdotadas: '¿Qué acciones adicionales se deben tomar?',
		eventoOperacionalRelatadoAspectos:
			'El evento de seguridad operacional informado (ESO) involucra uno de los siguientes aspectos',
		remetente: 'Nombre del remitente',
		enviadaEm: 'Respuesta enviada al Relator sobre',
		codigoOACI: 'Código de la OACI',
		executivo: 'Ejecutivo',
		questionarioGestorSegurancaOperacional: 'Sobre el gerente de seguridad operacional',
		informante: 'Quien reportó',
		tipoSituacao: 'Tipo de situación',
		condicoesPRE: 'Condiciones bajo las cuales se ha activado <PRE> <PLEM>',
		existiaExemplar: 'Hubo una copia <PRE> <PLEM>?',
		exemplarAtualizado: 'Se actualizó la copia <PRE> <PLEM>?',
		comoFoiAcionado: 'Cómo se activó',
		informacoesAtenderam: 'La información satisfizo las necesidades?',
		deficienciasIdentificadas: 'Deficiencias encontradas en la información',
		acionadoOrgaosExternos: 'Se han activado los órganos externos que forman parte de <PRE-XXX> y / o <PLEM-SXXX>?',
		orgaosEnvolvidos: 'Cuerpos externos involucrados',
		houveDerramamentoCombustivel: 'Se derramó combustible o aceite en la pista o ubicación?',
		pistaInterditada: 'Estaba bloqueada la pista?',
		tempoPistaInterditada: 'Tiempo de seguimiento bloqueado',
		paralisacaoOperacoes: 'Se detuvieron las operaciones?',
		tempoRetomadaOperacoes: 'Hora en que las operaciones volvieron a la normalidad',
		recursosDisponiveisForamAdequados:
			'Los recursos disponibles en <PRE-XXX> y / o <PLEM-SXXX> fueron adecuados y suficientes para el desmantelamiento de la pista?',
		deficienciasPorFaltaRecursos: 'Deficiencias identificadas',
		evacuacaoTripulantes: 'Descripción de la evacuación de la tripulación / pasajeros.',
		disponibilizacaoAcomodacoes: 'Se ha puesto a disposición de los miembros de la familia y del público en general?',
		outrasInformacoes: 'Otras informaciones',
		cliente: 'Cliente',
		analiseFinal: 'Análisis Finales',
	},
	menuEdicaoDiario: {
		tempoDeVoo: 'Tiempo de vuelo',
		horimetroFinal: 'Horas finales de vuelo',
		horimetroInicial: 'Horas iniciales de vuelo',
		nenhumEmpenhoAdicionado: 'Sin esfuerzo agregado',
		nenhumMotorAdicionado: 'Sin motor agregado'
	}
}
